webpackJsonp([1],{

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(570)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(566),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Maincategory__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Maincategory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Maincategory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Dashboard_MaincategoryYear__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Dashboard_MaincategoryYear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Dashboard_MaincategoryYear__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Dashboard_MaincategoryHatg__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Dashboard_MaincategoryHatg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Dashboard_MaincategoryHatg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Dashboard_MaincategoryAtg__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Dashboard_MaincategoryAtg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Dashboard_MaincategoryAtg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Dashboard_Brand__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Dashboard_Brand___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Dashboard_Brand__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Dashboard_BrandYear__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Dashboard_BrandYear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Dashboard_BrandYear__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Dashboard_BrandBrand__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Dashboard_BrandBrand___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Dashboard_BrandBrand__);














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    base: __dirname,
    routes: [{
        path: '/',
        redirect: '/dashboard'
    }, {
        path: '/app',
        component: __WEBPACK_IMPORTED_MODULE_2__App___default.a,
        children: [
        /*
        {
          path: '/auth/login',
          component: Login,
          name: 'Login',
        },
        {
          path: '/auth/logout',
          component: Logout,
          name: 'Logout',
        },
        */
        {
            path: '/dashboard',
            component: __WEBPACK_IMPORTED_MODULE_3__components_Dashboard___default.a,
            name: 'dashboard',
            children: [{
                path: 'stats/maincategories',
                component: __WEBPACK_IMPORTED_MODULE_3__components_Dashboard___default.a,
                name: 'dsm'
            }, {
                path: 'stats/maincategories/:year',
                component: __WEBPACK_IMPORTED_MODULE_3__components_Dashboard___default.a,
                name: 'dsmy',
                children: [{
                    path: ':cat',
                    component: __WEBPACK_IMPORTED_MODULE_3__components_Dashboard___default.a,
                    name: 'dsmc',
                    children: [{
                        path: ':scat',
                        component: __WEBPACK_IMPORTED_MODULE_3__components_Dashboard___default.a,
                        name: 'dsms'
                    }]
                }]
            }, {
                path: 'stats/brands',
                component: __WEBPACK_IMPORTED_MODULE_3__components_Dashboard___default.a,
                name: 'dsb'
            }, {
                path: 'stats/brands/:brandyear',
                component: __WEBPACK_IMPORTED_MODULE_3__components_Dashboard___default.a,
                name: 'dsby',
                children: [{
                    path: ':brandbrand',
                    component: __WEBPACK_IMPORTED_MODULE_3__components_Dashboard___default.a,
                    name: 'dsbb',
                    children: [{
                        path: ':brandscat',
                        component: __WEBPACK_IMPORTED_MODULE_3__components_Dashboard___default.a,
                        name: 'dsbs'
                    }]
                }]
            }, {
                // UserProfile wird innerhalb der
                // <router-view> von User gerendert,
                // wenn '/user/:id/profile' gematched wird.
                path: 'statistics/maincategories',
                component: __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Maincategory___default.a,
                name: 'statisticsmc'
            }, {
                // UserProfile wird innerhalb der
                // <router-view> von User gerendert,
                // wenn '/user/:id/profile' gematched wird.
                path: 'statistics/maincategories/:year',
                component: __WEBPACK_IMPORTED_MODULE_5__components_Dashboard_MaincategoryYear___default.a,
                name: 'statisticsmcy'
            }, {
                // UserProfile wird innerhalb der
                // <router-view> von User gerendert,
                // wenn '/user/:id/profile' gematched wird.
                path: 'statistics/maincategories/:year/:hatg',
                component: __WEBPACK_IMPORTED_MODULE_6__components_Dashboard_MaincategoryHatg___default.a,
                name: 'statisticsmcyh'
            }, {
                // UserProfile wird innerhalb der
                // <router-view> von User gerendert,
                // wenn '/user/:id/profile' gematched wird.
                path: 'statistics/maincategories/:year/:hatg/:atg',
                component: __WEBPACK_IMPORTED_MODULE_7__components_Dashboard_MaincategoryAtg___default.a,
                name: 'statisticsmcyha'
            }, {
                // UserProfile wird innerhalb der
                // <router-view> von User gerendert,
                // wenn '/user/:id/profile' gematched wird.
                path: 'statistics/brands',
                component: __WEBPACK_IMPORTED_MODULE_8__components_Dashboard_Brand___default.a,
                name: 'statisticsb'
            }, {
                // UserProfile wird innerhalb der
                // <router-view> von User gerendert,
                // wenn '/user/:id/profile' gematched wird.
                path: 'statistics/brands/:year',
                component: __WEBPACK_IMPORTED_MODULE_9__components_Dashboard_BrandYear___default.a,
                name: 'statisticsby'
            }, {
                // UserProfile wird innerhalb der
                // <router-view> von User gerendert,
                // wenn '/user/:id/profile' gematched wird.
                path: 'statistics/brands/:year/:brand',
                component: __WEBPACK_IMPORTED_MODULE_10__components_Dashboard_BrandBrand___default.a,
                name: 'statisticsbyb'
            }]
        }]
    }]
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(563),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(534)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(561),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Layout__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Layout__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: { Layout: __WEBPACK_IMPORTED_MODULE_0__components_Layout___default.a },
  data: function data() {
    return {
      user: null,
      token: null,
      authenticated: true
    };
  },

  methods: {
    login: function login(user) {
      this.user = user;
      this.authenticated = true;
      this.token = localStorage.getItem('jwt-token');
    },
    extlogin: function extlogin(user) {
      //console.log(user)
      this.user = user;
      this.authenticated = true;
      this.token = localStorage.getItem('ext-token');
      this.$router.push('/dashboard/statistics/maincategories');
    },
    logout: function logout(user) {
      this.user = null;
      this.token = null;
      this.authenticated = false;
      localStorage.removeItem('jwt-token');
      if (this.$route.auth) this.$router.push('/auth/login');
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$on('userLoggedIn', function (user) {
      _this.login(user);
    });

    this.$on('userLoggedOut', function (user) {
      _this.logout(user);
    });

    var token = localStorage.getItem('jwt-token');
    if (token !== null && token !== 'undefined' && !localStorage.getItem('ext-token')) {
      //alert(11)
      var that = this;
      that.$http.get('/api/users/details').then(function (response) {
        that.login(response.json()['data']);
      }, function (response) {
        that.logout();
      });
    } else if (this.$route.query.token != null && this.$route.query.token != 'undefined' || localStorage.getItem('ext-token')) {
      //alert(22)      
      var that = this;
      //if(this.$route.query.kb!='') user.kb = this.$route.query.kb
      localStorage.setItem('ext-token', this.$route.query.token ? this.$route.query.token : localStorage.getItem('ext-token'));
      localStorage.setItem('ext-kunde', this.$route.query.kunde ? this.$route.query.kunde : localStorage.getItem('ext-kunde'));
      localStorage.setItem('ext-kb', this.$route.query.kb ? this.$route.query.kb : localStorage.getItem('ext-kb'));

      //alert( localStorage.getItem('ext-kunde') )

      that.extlogin({ pno: localStorage.getItem('ext-kunde'), name: '', username: '' });
    } else {
      //alert(33)
      this.$router.push('/auth/login');
    }
  }
});

/***/ }),

/***/ 217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_StatsMaincategory__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_StatsMaincategory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_StatsMaincategory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_StatsBrand__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_StatsBrand___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_StatsBrand__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dashboard',
  components: { StatsMaincategory: __WEBPACK_IMPORTED_MODULE_0__components_StatsMaincategory___default.a, StatsBrand: __WEBPACK_IMPORTED_MODULE_1__components_StatsBrand___default.a },
  data: function data() {
    return {
      years: 'test',
      names: {
        hatg: '',
        atg: '',
        brand: ''
      },
      loader: 0
    };
  },

  methods: {
    setName: function setName(type, value) {
      if (type == 'hatg') {
        this.names.hatg = value;
      }
      if (type == 'atg') {
        this.names.atg = value;
      }
      if (type == 'brand') {
        this.names.brand = value;
      }
    }
  }
});

/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'back',
  props: ['link'],
  data: function data() {
    return {};
  },

  mounted: function mounted() {},
  watch: {},
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {},

  methods: {
    redirect: function redirect() {
      this.$router.push(this.link);
    }
  }
});

/***/ }),

/***/ 219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years__);
//
//



var c3 = __webpack_require__(11);
var d3 = __webpack_require__(55);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'brand',
  components: { Back: __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back___default.a, Searchfield: __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield___default.a, Settings: __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings___default.a, Years: __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years___default.a },
  data: function data() {
    return {
      years: [],
      year: '',
      showmore: false,
      sort: 'revenues',
      showEG: 0,
      yearslink: '/dashboard/statistics/brands/' + this.year
    };
  },

  mounted: function mounted() {
    var date = new Date();
    this.year = date.getFullYear();

    this.fetchData();
  },
  watch: {},
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {},

  methods: {
    format: function format(value) {
      var me = this;
      d3.formatDefaultLocale({
        "decimal": ",",
        "thousands": ",",
        "grouping": [3],
        "currency": ["", "€"]
      });
      //return d3.format("$,")(value);
    },
    fetchData: function fetchData() {
      var _this = this;

      this.$parent.loader = 1;

      var url = this.$serviceurl + 'statistik/jahresumsaetze/kunde/' + localStorage.getItem('ext-kunde');
      var headers = {
        'Access-Control-Allow-Origin': '*',
        'Accept': 'application/json',
        'app-version': '2.2',
        'token': localStorage.getItem('ext-token')
      };
      var options = {
        headers: headers
      };

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url + '?token=' + localStorage.getItem('ext-token') + '&sort=' + this.sort + '&jahr=' + this.year, options).then(function (response) {
        /*this.years = response.data;*/
        _this.setYears(response.data);
        localStorage.setItem('years', response.data);
        _this.drawChart();
        _this.$parent.loader = 0;
      }).catch(function (e) {
        //console.log(e)
      });
    },
    drawChart: function drawChart(update) {
      var me = this;
      if (update) {
        setTimeout(function () {
          var aY = [['WQ'], ['GQ']];
          if (me.showEG == 1) aY.push(['GSP']);
          for (var i = 0; i < me.years[0].length; i++) {
            aY[0].push('' + me.years[0][i].webQuote + '');
            aY[1].push(me.years[0][i].gutschriftenQuote);
            if (me.showEG == 1) aY[2].push(me.years[0][i].gewinnSpanne);
          }
          if (me.showEG == 1) {
            var cols = [aY[0], aY[1], aY[2]];
          } else {
            var cols = [aY[0], aY[1]];
          }
          chart.load({
            columns: cols,
            /*[
              ['GSP', me.years[0][3].gewinnSpanne, me.years[0][2].gewinnSpanne, me.years[0][1].gewinnSpanne, me.years[0][0].gewinnSpanne],
              ['WQ', me.years[0][3].webQuote, me.years[0][2].webQuote, me.years[0][1].webQuote, me.years[0][0].webQuote],
              ['GQ', me.years[0][3].gutschriftenQuote, me.years[0][2].gutschriftenQuote, me.years[0][1].gutschriftenQuote, me.years[0][0].gutschriftenQuote],
            ],*/
            unload: ['Umsatz', 'Erloes']
          });
        }, 0);
      }

      var aY = [['x'], ['Umsatz']];
      if (this.showEG == 1) aY.push(['Erloes']);

      for (var i = 0; i < this.years[0].length; i++) {
        aY[0].push('' + this.years[0][i].jahr + '');
        aY[1].push(this.years[0][i].umsatz);
        if (this.showEG == 1) aY[2].push(this.years[0][i].erloes);
      }

      if (this.showEG == 1) {
        var cols = [aY[0], aY[1], aY[2]];
      } else {
        var cols = [aY[0], aY[1]];
      }

      this.format();

      var chart = c3.generate({
        bindto: '#yCustomerChart',
        size: {
          height: 240
        },
        padding: {
          //top: 40,
          right: 30
          //bottom: 40,
          //left: 100,
        },
        color: {
          pattern: ['blue', 'green', 'orange']
        },
        data: {
          x: 'x',
          xFormat: '%Y', // 'xFormat' can be used as custom format of 'x'
          columns: cols
          /*[
              aY[0],
              aY[1],
              aY[2],
              //['x', '2014', '2015', '2016', '2017'],
              //['x', '20130101', '20130102', '20130103', '20130104', '20130105', '20130106'],
              //['Umsatz', this.years[0][3].umsatz, this.years[0][2].umsatz, this.years[0][1].umsatz, this.years[0][0].umsatz],
              //['Erloes', this.years[0][3].erloes, this.years[0][2].erloes, this.years[0][1].erloes, this.years[0][0].erloes],              
          ]*/
        },
        axis: {
          x: {
            type: 'timeseries',
            tick: {
              format: '%Y'
            }
          },
          y: {
            tick: {
              format: d3.format("$,")
            }
          }
        },
        tooltip: {
          format: {
            //title: function (d) { return 'Data ' + d; },
            value: function value(_value, ratio, id) {
              var format = d3.format(',');
              return format(_value);
            }
            //            value: d3.format(',') // apply this format to both y and y2
          }
        }
      });
    },
    /*
    drawChart: function() {
      var chart = c3.generate({
        bindto: '#yCustomerChart',
        size: {
            height: 240
        },
        padding: {
            //top: 40,
            right: 30,
            //bottom: 40,
            //left: 100,
        },
        color: {
            pattern: ['blue', 'green', 'lila', 'orange']
        },
        data: {
          x: 'x',
            xFormat: '%Y', // 'xFormat' can be used as custom format of 'x'
          columns: [
              ['x', '2014', '2015', '2016', '2017'],
              //['x', '20130101', '20130102', '20130103', '20130104', '20130105', '20130106'],
              ['Umsatz', this.years[0][3].umsatz, this.years[0][2].umsatz, this.years[0][1].umsatz, this.years[0][0].umsatz],
              ['Erloes', this.years[0][3].erloes, this.years[0][2].erloes, this.years[0][1].erloes, this.years[0][0].erloes],
              ['GSP', this.years[0][3].gewinnSpanne, this.years[0][2].gewinnSpanne, this.years[0][1].gewinnSpanne, this.years[0][0].gewinnSpanne],
              ['WQ', this.years[0][3].webQuote, this.years[0][2].webQuote, this.years[0][1].webQuote, this.years[0][0].webQuote],
          ]
        },
        axis: {
            x: {
                type: 'timeseries',
                tick: {
                    format: '%Y'
                }
            }
        }
      })
    },
    */
    setYears: function setYears(data) {
      var asc = [];
      var desc = [];
      for (var i = 0; i < data.length; i++) {
        asc[i] = data[i];
        desc[i] = data[i];
      }
      desc = desc.reverse();
      this.years.push(asc);
      this.years.push(desc);

      this.$parent.years = this.years;
    },
    getRandomArbitrary: function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    },
    setName: function setName(type, value) {
      this.$parent.setName(type, value);
    }
  }
});

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(537)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(565),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years__);
//
//



var c3 = __webpack_require__(11);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'brandbrand',
  components: { Back: __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back___default.a, Searchfield: __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield___default.a, Settings: __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings___default.a, Years: __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years___default.a },
  data: function data() {
    return {
      years: this.$parent.years,
      year: '',
      atgs: [],
      tmpAtgs: [],
      showmore: false,
      sort: 'revenues',
      link: '/dashboard/statistics/brands/' + this.$route.params.year,
      searchword: '',
      mode: '1',
      sum: 0,
      showUE: 0,
      modus: 'top',
      period: ''
    };
  },

  mounted: function mounted() {
    this.year = this.$route.params.year;

    this.fetchData();
  },
  methods: {
    dateRedirect: function dateRedirect() {
      this.$router.push('/dashboard/statistics/brands/' + this.year);
      this.fetchData();
    },
    reduceList: function reduceList(searchword) {
      if (this.tmpAtgs.length == 0) {
        this.tmpAtgs = this.atgs;
      }

      if (searchword != "") {

        this.atgs = this.atgs.filter(function (cat) {
          return cat.name.toLowerCase().indexOf(searchword.toLowerCase()) >= 0;
        });
      } else {

        this.atgs = this.tmpAtgs;
      }
    },
    fetchData: function fetchData() {
      var _this = this;

      this.$parent.loader = 1;

      var url = this.$serviceurl + 'statistik/umsatz/marken/kunde/' + localStorage.getItem('ext-kunde') + '/marke/' + this.$route.params.brand;
      var headers = {
        'Access-Control-Allow-Origin': '*',
        'Accept': 'application/json',
        'app-version': '2.2',
        'token': localStorage.getItem('ext-token')
      };
      var options = {
        headers: headers
      };

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url + '?token=' + localStorage.getItem('ext-token') + '&sort=' + this.sort + '&jahr=' + this.year + '&periode=' + this.period, options).then(function (response) {
        _this.atgs = response.data;
        if (_this.modus == 'top') {
          _this.atgs = _this._.orderBy(_this.atgs, ['umsatzLj'], ['desc']);
        }
        if (_this.modus == 'flop') {
          _this.atgs = _this._.orderBy(_this.atgs, ['umsatzLj'], ['asc']);
        }
        /*this.loaderSm = false;*/
        _this.drawChart();
        _this.$parent.loader = 0;
        if (_this.searchword != "") _this.reduceList(_this.searchword);
      }).catch(function (e) {
        //console.log(e)
      });
    },
    drawChart: function drawChart() {
      var dataLj = [[], [], [], [], [], []];

      var columnsArr = [];

      var showChart = false;

      for (var index = 0; index < this.atgs.length; index++) {
        if (index < 5) {
          if (this.mode == '1') {
            columnsArr.push([this.atgs[index].name, this.atgs[index].umsatzLj]);
          } else {
            columnsArr.push([this.atgs[index].name, this.atgs[index].umsatzLj]);
          }
          if (this.atgs[index].umsatzLj > 0) {
            showChart = true;
          }
          dataLj[0].push(this.atgs[index].id);
          dataLj[1].push(this.atgs[index].name);
          dataLj[2].push(this.atgs[index].umsatzLj);
          dataLj[3].push(this.atgs[index].umsatzVj);
          dataLj[4].push(this.atgs[index].erloesLj);
          dataLj[5].push(this.atgs[index].erloesVj);
        }
      }

      var sumArray = this._.slice(this.atgs, 5);
      var sum = this._.sumBy(sumArray, 'umsatzLj');
      this.sum = sum;

      var greys = ['#878787', '#9d9d9c', '#b2b2b2', '#dadada', '#ededed'];
      var colors = ['#003366', '#1d71b8', '#00a19a', '#66aa66', '#006633'];
      var mixed = [];

      if (showChart) {
        var pie_chart = c3.generate({
          bindto: "#yCustomerChart",
          size: { width: 300, height: 300 },
          color: {
            pattern: colors
          },
          data: {
            columns: columnsArr,
            type: 'pie'
          }
        });
      } else {
        $("#yCustomerChart" + this.mode).html('');
      }
    }
  }
});

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years__);
//
//



var c3 = __webpack_require__(11);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'brandyear',
  components: { Back: __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back___default.a, Searchfield: __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield___default.a, Settings: __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings___default.a, Years: __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years___default.a },
  data: function data() {
    return {
      years: this.$parent.years,
      year: '',
      brands: [],
      tmpBrands: [],
      showmore: false,
      sort: 'revenues',
      searchword: '',
      mode: '1',
      sum: 0,
      showUE: 0,
      modus: 'top',
      period: ''
    };
  },

  mounted: function mounted() {
    this.year = this.$route.params.year;

    this.fetchData();
  },
  methods: {
    dateRedirect: function dateRedirect() {
      this.$router.push('/dashboard/statistics/brands/' + this.year);
      this.fetchData();
    },
    reduceList: function reduceList(searchword) {
      if (this.tmpBrands.length == 0) {
        this.tmpBrands = this.brands;
      }

      if (searchword != "") {

        this.brands = this.brands.filter(function (cat) {
          return cat.name.toLowerCase().indexOf(searchword.toLowerCase()) >= 0;
        });
      } else {

        this.brands = this.tmpBrands;
      }
    },
    fetchData: function fetchData() {
      var _this = this;

      this.$parent.loader = 1;

      var url = this.$serviceurl + 'statistik/umsatz/marken/kunde/' + localStorage.getItem('ext-kunde');
      var headers = {
        'Access-Control-Allow-Origin': '*',
        'Accept': 'application/json',
        'app-version': '2.2',
        'token': localStorage.getItem('ext-token')
      };
      var options = {
        headers: headers
      };

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url + '?token=' + localStorage.getItem('ext-token') + '&sort=' + this.sort + '&jahr=' + this.year + '&periode=' + this.period, options).then(function (response) {
        _this.brands = response.data;
        if (_this.modus == 'top') {
          _this.brands = _this._.orderBy(_this.brands, ['umsatzLj'], ['desc']);
        }
        if (_this.modus == 'flop') {
          _this.brands = _this._.orderBy(_this.brands, ['umsatzLj'], ['asc']);
        }
        /*this.loaderSm = false;*/
        _this.drawChart();
        _this.$parent.loader = 0;
        if (_this.searchword != "") _this.reduceList(_this.searchword);
      }).catch(function (e) {
        //console.log(e)
      });
    },
    drawChart: function drawChart() {
      var dataLj = [[], [], [], [], [], []];

      var columnsArr = [];

      var showChart = false;

      for (var index = 0; index < this.brands.length; index++) {
        if (index < 5) {
          if (this.mode == '1') {
            columnsArr.push([this.brands[index].name, this.brands[index].umsatzLj]);
          } else {
            columnsArr.push([this.brands[index].name, this.brands[index].umsatzLj]);
          }
          if (this.brands[index].umsatzLj > 0) {
            showChart = true;
          }
          dataLj[0].push(this.brands[index].id);
          dataLj[1].push(this.brands[index].name);
          dataLj[2].push(this.brands[index].umsatzLj);
          dataLj[3].push(this.brands[index].umsatzVj);
          dataLj[4].push(this.brands[index].erloesLj);
          dataLj[5].push(this.brands[index].erloesVj);
        }
      }

      var sumArray = this._.slice(this.brands, 5);
      var sum = this._.sumBy(sumArray, 'umsatzLj');
      this.sum = sum;

      var greys = ['#878787', '#9d9d9c', '#b2b2b2', '#dadada', '#ededed'];
      var colors = ['#003366', '#1d71b8', '#00a19a', '#66aa66', '#006633'];
      var mixed = [];

      if (showChart) {
        var pie_chart = c3.generate({
          bindto: "#yCustomerChart",
          size: { width: 300, height: 300 },
          color: {
            pattern: colors
          },
          data: {
            columns: columnsArr,
            type: 'pie'
          }
        });
      } else {
        $("#yCustomerChart" + this.mode).html('');
      }
    },
    setName: function setName(type, value) {
      this.$parent.setName(type, value);
    }
  }
});

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years__);
//
//



var c3 = __webpack_require__(11);
var d3 = __webpack_require__(55);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'maincategory',
  components: { Back: __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back___default.a, Searchfield: __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield___default.a, Settings: __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings___default.a, Years: __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years___default.a },
  data: function data() {
    return {
      years: [],
      year: '',
      showmore: false,
      sort: 'revenues',
      showEG: 0,
      yearslink: '/dashboard/statistics/maincategories/' + this.year
    };
  },

  mounted: function mounted() {
    var date = new Date();
    this.year = date.getFullYear();

    this.fetchData();
  },
  watch: {},
  computed: {},
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {},

  methods: {
    format: function format(value) {
      var me = this;
      d3.formatDefaultLocale({
        "decimal": ",",
        "thousands": ",",
        "grouping": [3],
        "currency": ["", "€"]
      });
      //return d3.format("$,")(value);
    },
    fetchData: function fetchData() {
      var _this = this;

      this.$parent.loader = 1;

      var url = this.$serviceurl + 'statistik/jahresumsaetze/kunde/' + localStorage.getItem('ext-kunde');
      var headers = {
        'Access-Control-Allow-Origin': '*',
        'Accept': 'application/json',
        'app-version': '2.2',
        'token': localStorage.getItem('ext-token')
      };
      var options = {
        headers: headers
      };

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url + '?token=' + localStorage.getItem('ext-token') + '&sort=' + this.sort + '&jahr=' + this.year, options).then(function (response) {
        /*this.years = response.data;*/
        _this.setYears(response.data);
        localStorage.setItem('years', response.data);
        _this.drawChart();
        _this.$parent.loader = 0;
      }).catch(function (e) {
        //console.log(e)
      });
    },
    drawChart: function drawChart(update) {
      var me = this;
      if (update) {

        setTimeout(function () {
          var aY = [['WQ'], ['GQ']];
          if (me.showEG == 1) aY.push(['GSP']);
          for (var i = 0; i < me.years[0].length; i++) {
            aY[0].push('' + me.years[0][i].webQuote + '');
            aY[1].push(me.years[0][i].gutschriftenQuote);
            if (me.showEG == 1) aY[2].push(me.years[0][i].gewinnSpanne);
          }
          if (me.showEG == 1) {
            var cols = [aY[0], aY[1], aY[2]];
          } else {
            var cols = [aY[0], aY[1]];
          }
          chart.load({
            columns: cols,
            unload: ['Umsatz', 'Erloes']
          });
        }, 0);
      }

      var aY = [['x'], ['Umsatz']];
      if (this.showEG == 1) aY.push(['Erloes']);

      for (var i = 0; i < this.years[0].length; i++) {
        aY[0].push('' + this.years[0][i].jahr + '');
        aY[1].push(this.years[0][i].umsatz);
        if (this.showEG == 1) aY[2].push(this.years[0][i].erloes);
      }

      if (this.showEG == 1) {
        var cols = [aY[0], aY[1], aY[2]];
      } else {
        var cols = [aY[0], aY[1]];
      }

      this.format();

      var chart = c3.generate({
        bindto: '#yCustomerChart',
        size: {
          height: 240
        },
        padding: {
          //top: 40,
          right: 30
          //bottom: 40,
          //left: 100,
        },
        color: {
          pattern: ['blue', 'green', 'orange']
        },
        data: {
          x: 'x',
          xFormat: '%Y', // 'xFormat' can be used as custom format of 'x'
          columns: cols
          /*[
              aY[0],
              aY[1],
              aY[2],
              //['x', '20130101', '20130102', '20130103', '20130104', '20130105', '20130106'],
              //['Umsatz', this.years[0][3].umsatz, this.years[0][2].umsatz, this.years[0][1].umsatz, this.years[0][0].umsatz],
              //['Erloes', this.years[0][3].erloes, this.years[0][2].erloes, this.years[0][1].erloes, this.years[0][0].erloes],              
          ]*/
        },
        axis: {
          x: {
            type: 'timeseries',
            tick: {
              format: '%Y'
            }
          },
          y: {
            tick: {
              format: d3.format("$,")
            }
          }
        }
      });
    },
    drawCustomerGraph: function drawCustomerGraph() {},
    setYears: function setYears(data) {
      var asc = [];
      var desc = [];
      for (var i = 0; i < data.length; i++) {
        asc[i] = data[i];
        desc[i] = data[i];
      }
      desc = desc.reverse();
      this.years.push(asc);
      this.years.push(desc);

      this.$parent.years = this.years;
    },
    getRandomArbitrary: function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    },
    setBrandName: function setBrandName(type, value) {}
  }
});

/***/ }),

/***/ 223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years__);
//
//



var c3 = __webpack_require__(11);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'maincategoryAtg',
  components: { Back: __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back___default.a, Searchfield: __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield___default.a, Settings: __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings___default.a, Years: __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years___default.a },
  data: function data() {
    return {
      years: this.$parent.years,
      year: '',
      brands: [],
      tmpBrands: [],
      showmore: false,
      sort: 'revenues',
      searchword: '',
      mode: '1',
      sum: 0,
      showUE: 0,
      modus: 'top',
      period: ''
    };
  },

  watch: {
    mode: function mode() {
      this.$nextTick(function () {
        this.fetchData();
      });
    }
  },
  computed: {
    link: function link() {
      return '/dashboard/statistics/maincategories/' + this.$route.params.year + '/' + this.$route.params.hatg;
    }
  },
  mounted: function mounted() {
    this.year = this.$route.params.year;

    this.fetchData();
  },
  methods: {
    dateRedirect: function dateRedirect() {
      this.$router.push('/dashboard/statistics/maincategories/' + this.year + '/' + this.$route.params.hatg + '/' + this.$route.params.atg);
      this.fetchData();
    },
    reduceList: function reduceList(searchword) {
      if (this.tmpBrands.length == 0) {
        this.tmpBrands = this.brands;
      }

      if (searchword != "") {

        this.brands = this.brands.filter(function (cat) {
          return cat.name.toLowerCase().indexOf(searchword.toLowerCase()) >= 0;
        });
      } else {

        this.brands = this.tmpBrands;
      }
    },
    fetchData: function fetchData() {
      var _this = this;

      this.$parent.loader = 1;

      var url = this.$serviceurl + 'statistik/umsatz/hatg/kunde/' + localStorage.getItem('ext-kunde') + '/hatg/' + this.$route.params.hatg + '/atg/' + this.$route.params.atg;

      var headers = { 'Access-Control-Allow-Origin': '*', 'Accept': 'application/json', 'app-version': '2.2', 'token': localStorage.getItem('ext-token') };
      var options = { headers: headers };

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url + '?token=' + localStorage.getItem('ext-token') + '&sort=' + this.sort + '&jahr=' + this.year + '&periode=' + this.period, options).then(function (response) {
        _this.$parent.loader = 0;
        _this.brands = response.data;
        if (_this.modus == 'top') {
          _this.brands = _this._.orderBy(_this.brands, ['umsatzLj'], ['desc']);
        }
        if (_this.modus == 'flop') {
          _this.brands = _this._.orderBy(_this.brands, ['umsatzLj'], ['asc']);
        }
        _this.drawChart();

        if (_this.searchword != "") _this.reduceList(_this.searchword);
      }).catch(function (e) {
        //console.log(e)
      });
    },
    drawChart: function drawChart() {
      var tmpCat = this.subcategories;

      if (this.mode != '1') {
        this.subcategories = this._.orderBy(this.subcategories, ['erloesLj'], ['desc']);
      } else {
        this.subcategories = tmpCat;
      }

      var dataLj = [[], [], [], [], [], []];

      var columnsArr = [];

      var showChart = false;

      for (var index = 0; index < this.subcategories.length; index++) {
        if (index < 5) {
          if (this.mode == '1') {
            columnsArr.push([this.subcategories[index].name, this.subcategories[index].umsatzLj]);
          } else {
            columnsArr.push([this.subcategories[index].name, this.subcategories[index].umsatzLj]);
          }
          if (this.subcategories[index].umsatzLj > 0) {
            showChart = true;
          }
          dataLj[0].push(this.subcategories[index].id);
          dataLj[1].push(this.subcategories[index].name);
          dataLj[2].push(this.subcategories[index].umsatzLj);
          dataLj[3].push(this.subcategories[index].umsatzVj);
          dataLj[4].push(this.subcategories[index].erloesLj);
          dataLj[5].push(this.subcategories[index].erloesVj);
        }
      }

      var sumArray = this._.slice(this.brands, 5);
      var sum = this._.sumBy(sumArray, 'umsatzLj');
      this.sum = sum;

      var greys = ['#878787', '#9d9d9c', '#b2b2b2', '#dadada', '#ededed'];
      var colors = ['#003366', '#1d71b8', '#00a19a', '#66aa66', '#006633'];
      var mixed = [];

      this.$parent.loader = 0;

      if (showChart) {
        var pie_chart = c3.generate({
          bindto: "#brandCustomerChart" + this.mode,
          size: { width: 300, height: 300 },
          color: {
            pattern: colors
          },
          data: {
            columns: columnsArr,
            type: 'pie'
          }
        });
      } else {
        $("#brandCustomerChart" + this.mode).html('');
      }
    },
    getRandomArbitrary: function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    },
    setName: function setName(type, value) {
      this.$parent.setName(type, value);
    }
  }
});

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years__);
//
//



var c3 = __webpack_require__(11);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'maincategoryHatg',
  components: { Back: __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back___default.a, Searchfield: __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield___default.a, Settings: __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings___default.a, Years: __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years___default.a },
  data: function data() {
    return {
      years: this.$parent.years,
      year: '',
      subcategories: [],
      tmpSubcategories: [],
      showmore: false,
      sort: 'revenues',
      searchword: '',
      sum: 0,
      mode: '1',
      showUE: 0,
      modus: 'top',
      period: ''
    };
  },

  computed: {
    link: function link() {
      return '/dashboard/statistics/maincategories/' + this.$route.params.year;
    }
  },
  watch: {
    mode: function mode() {
      this.$nextTick(function () {
        this.fetchData();
      });
    }
  },
  mounted: function mounted() {
    this.year = this.$route.params.year;

    this.fetchData();
  },
  methods: {
    dateRedirect: function dateRedirect() {
      this.$router.push('/dashboard/statistics/maincategories/' + this.year + '/' + this.$route.params.hatg);
      this.fetchData();
    },
    reduceList: function reduceList(searchword) {
      if (this.tmpSubcategories.length == 0) {
        this.tmpSubcategories = this.subcategories;
      }

      if (searchword != "") {

        this.subcategories = this.subcategories.filter(function (cat) {
          return cat.name.toLowerCase().indexOf(searchword.toLowerCase()) >= 0;
        });
      } else {

        this.subcategories = this.tmpSubcategories;
      }
    },
    fetchData: function fetchData() {
      var _this = this;

      this.$parent.loader = 1;
      var url = this.$serviceurl + 'statistik/umsatz/hatg/kunde/' + localStorage.getItem('ext-kunde') + '/hatg/' + this.$route.params.hatg;
      var headers = { 'Access-Control-Allow-Origin': '*', 'Accept': 'application/json', 'app-version': '2.2', 'token': localStorage.getItem('ext-token') };
      var options = { headers: headers };

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url + '?token=' + localStorage.getItem('ext-token') + '&sort=' + this.sort + '&jahr=' + this.year + '&periode=' + this.period, options).then(function (response) {
        _this.subcategories = response.data;
        if (_this.modus == 'top') {
          _this.subcategories = _this._.orderBy(_this.subcategories, ['umsatzLj'], ['desc']);
        }
        if (_this.modus == 'flop') {
          _this.subcategories = _this._.orderBy(_this.subcategories, ['umsatzLj'], ['asc']);
        }
        _this.drawChart();
        _this.$parent.loader = 0;

        if (_this.searchword != "") _this.reduceList(_this.searchword);
      }).catch(function (e) {
        //console.log(e)
      });
    },
    drawChart: function drawChart() {
      var tmpCat = this.subcategories;

      if (this.mode != '1') {
        this.subcategories = this._.orderBy(this.subcategories, ['erloesLj'], ['desc']);
      } else {
        this.subcategories = tmpCat;
      }

      var dataLj = [[], [], [], [], [], []];

      var columnsArr = [];

      var showChart = false;

      for (var index = 0; index < this.subcategories.length; index++) {
        if (index < 5) {
          if (this.mode == '1') {
            columnsArr.push([this.subcategories[index].name, this.subcategories[index].umsatzLj]);
          } else {
            columnsArr.push([this.subcategories[index].name, this.subcategories[index].umsatzLj]);
          }
          if (this.subcategories[index].umsatzLj > 0) {
            showChart = true;
          }
          dataLj[0].push(this.subcategories[index].id);
          dataLj[1].push(this.subcategories[index].name);
          dataLj[2].push(this.subcategories[index].umsatzLj);
          dataLj[3].push(this.subcategories[index].umsatzVj);
          dataLj[4].push(this.subcategories[index].erloesLj);
          dataLj[5].push(this.subcategories[index].erloesVj);
        }
      }

      var sumArray = this._.slice(this.subcategories, 5);
      var sum = this._.sumBy(sumArray, 'umsatzLj');
      this.sum = sum;

      var greys = ['#878787', '#9d9d9c', '#b2b2b2', '#dadada', '#ededed'];
      var colors = ['#003366', '#1d71b8', '#00a19a', '#66aa66', '#006633'];
      var mixed = [];

      if (showChart) {
        var pie_chart = c3.generate({
          bindto: "#atgCustomerChart" + this.mode,
          size: { width: 300, height: 300 },
          color: {
            pattern: colors
          },
          data: {
            columns: columnsArr,
            type: 'pie'
          }
        });
      } else {
        $("#atgCustomerChart" + this.mode).html('');
      }
    },
    getRandomArbitrary: function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    },
    setName: function setName(type, value) {
      this.$parent.setName(type, value);
    }
  }
});

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years__);
//
//



var c3 = __webpack_require__(11);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'maincategoryYear',
  components: { Back: __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Back___default.a, Searchfield: __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Searchfield___default.a, Settings: __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Settings___default.a, Years: __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Years___default.a },
  data: function data() {
    return {
      years: this.$parent.years,
      year: '',
      categories: [],
      tmpCategories: [],
      showmore: false,
      sort: 'revenues',
      searchword: '',
      mode: '1',
      sum: 0,
      showUE: 0,
      modus: 'top',
      period: ''
    };
  },

  mounted: function mounted() {
    this.year = this.$route.params.year;

    this.fetchData();
  },
  watch: {
    mode: function mode() {
      this.$nextTick(function () {
        this.fetchData();
      });
    }
  },
  methods: {
    dateRedirect: function dateRedirect() {
      this.$router.push('/dashboard/statistics/maincategories/' + this.year);
      this.fetchData();
    },
    reduceList: function reduceList(searchword) {
      if (this.tmpCategories.length == 0) {
        this.tmpCategories = this.categories;
      }

      if (searchword != "") {

        this.categories = this.categories.filter(function (cat) {
          return cat.name.toLowerCase().indexOf(searchword.toLowerCase()) >= 0;
        });
      } else {

        this.categories = this.tmpCategories;
      }
    },
    fetchData: function fetchData() {
      var _this = this;

      this.$parent.loader = 1;
      var url = this.$serviceurl + 'statistik/umsatz/hatg/kunde/' + localStorage.getItem('ext-kunde');
      var headers = { 'Access-Control-Allow-Origin': '*', 'Accept': 'application/json', 'app-version': '2.2', 'token': localStorage.getItem('ext-token') };
      var options = { headers: headers };

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url + '?token=' + localStorage.getItem('ext-token') + '&sort=' + this.sort + '&jahr=' + this.year + '&periode=' + this.period, options).then(function (response) {
        _this.categories = response.data;
        if (_this.modus == 'top') {
          _this.categories = _this._.orderBy(_this.categories, ['umsatzLj'], ['desc']);
        }
        if (_this.modus == 'flop') {
          _this.categories = _this._.orderBy(_this.categories, ['umsatzLj'], ['asc']);
        }
        _this.drawChart();
        _this.$parent.loader = 0;
        if (_this.searchword != "") _this.reduceList(_this.searchword);
      }).catch(function (e) {
        //console.log(e)
      });
    },
    drawChart: function drawChart() {
      var tmpCat = this.categories;

      if (this.mode != '1') {
        this.categories = this._.orderBy(this.categories, ['erloesLj'], ['desc']);
      } else {
        this.categories = tmpCat;
      }

      var dataLj = [[], [], [], [], [], []];

      var columnsArr = [];

      var showChart = false;

      for (var index = 0; index < this.categories.length; index++) {
        if (index < 5) {
          if (this.mode == '1') {
            columnsArr.push([this.categories[index].name, this.categories[index].umsatzLj]);
          } else {
            columnsArr.push([this.categories[index].name, this.categories[index].umsatzLj]);
          }
          if (this.categories[index].umsatzLj > 0) {
            showChart = true;
          }
          dataLj[0].push(this.categories[index].id);
          dataLj[1].push(this.categories[index].name);
          dataLj[2].push(this.categories[index].umsatzLj);
          dataLj[3].push(this.categories[index].umsatzVj);
          dataLj[4].push(this.categories[index].erloesLj);
          dataLj[5].push(this.categories[index].erloesVj);
        }
      }

      //console.log(columnsArr);

      /*
      var dataLj = [
        [
          this.categories[0].id,
          this.categories[1].id,
          this.categories[2].id,
          this.categories[3].id, 
          this.categories[4].id,
        ],
        [
          this.categories[0].name,
          this.categories[1].name,
          this.categories[2].name,
          this.categories[3].name, 
          this.categories[4].name,
        ],
        [
          this.categories[0].umsatzLj,
          this.categories[1].umsatzLj,
          this.categories[2].umsatzLj,
          this.categories[3].umsatzLj, 
          this.categories[4].umsatzLj,
        ],
        [
          this.categories[0].umsatzVj,
          this.categories[1].umsatzVj,
          this.categories[2].umsatzVj,
          this.categories[3].umsatzVj, 
          this.categories[4].umsatzVj,
        ],
        [
          this.categories[0].erloesLj,
          this.categories[1].erloesLj,
          this.categories[2].erloesLj,
          this.categories[3].erloesLj, 
          this.categories[4].erloesLj,
        ],
        [
          this.categories[0].erloesVj,
          this.categories[1].erloesVj,
          this.categories[2].erloesVj,
          this.categories[3].erloesVj, 
          this.categories[4].erloesVj,
        ]
      ];
      */

      /*if(this.mode=='1') {
        var columnsArr = [
          [dataLj[1][0], dataLj[2][0]],
          [dataLj[1][1], dataLj[2][1]],
          [dataLj[1][2], dataLj[2][2]],
          [dataLj[1][3], dataLj[2][3]],
          [dataLj[1][4], dataLj[2][4]],
        ]
      } else {
        var columnsArr = [
          [dataLj[1][0], dataLj[4][0]],
          [dataLj[1][1], dataLj[4][1]],
          [dataLj[1][2], dataLj[4][2]],
          [dataLj[1][3], dataLj[4][3]],
          [dataLj[1][4], dataLj[4][4]],
        ]
      }*/

      var sumArray = this._.slice(this.categories, 5);
      var sum = this._.sumBy(sumArray, 'umsatzLj');
      this.sum = sum;

      var greys = ['#878787', '#9d9d9c', '#b2b2b2', '#dadada', '#ededed'];
      var colors = ['#003366', '#1d71b8', '#00a19a', '#66aa66', '#006633'];
      var mixed = [];

      if (showChart) {
        var pie_chart = c3.generate({
          bindto: "#hatgCustomerChart" + this.mode,
          size: { width: 300, height: 300 },
          color: {
            pattern: colors
          },
          data: {
            columns: columnsArr,
            type: 'pie'
          }
        });
      } else {
        $("#hatgCustomerChart" + this.mode).html('');
      }
    },
    getRandomArbitrary: function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    },
    setName: function setName(type, value) {
      this.$parent.setName(type, value);
    }
  }
});

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Searchfield',
  props: ['count'],
  data: function data() {
    return {
      searchword: ''
    };
  },

  computed: {
    sort: function sort() {
      return this.$parent.sort;
    }
  },
  watch: {
    searchword: function searchword() {
      this.$parent.searchword = this.searchword;
      this.$parent.reduceList(this.searchword);
    }
  }
});

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'settings',
  props: ['mode'],
  data: function data() {
    return {
      show: 0,
      sort: 'revenues',
      showEG: 0,
      showUE: 0,
      modus: 'top',
      period: ''
    };
  },

  watch: {
    sort: function sort() {
      this.$parent.sort = this.sort;
      this.$parent.fetchData();
    },
    showEG: function showEG() {
      this.$parent.showEG = this.showEG;
      this.$parent.fetchData();
    },
    showUE: function showUE() {
      this.$parent.showUE = this.showUE;
      this.$parent.fetchData();
    },
    modus: function modus() {
      this.$parent.modus = this.modus;
      this.$parent.fetchData();
    },
    period: function period() {
      this.$parent.period = this.period;
      this.$parent.fetchData();
    }
  },
  methods: {
    resetSearch: function resetSearch() {
      this.$parent.searchword = '';
      this.$parent.reduceList('');
    },
    closeSettings: function closeSettings() {
      this.show = 0;
    },
    getRandomArbitrary: function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    }
  }
});

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'years',
  props: ['years', 'period'],
  methods: {
    setYear: function setYear(year) {
      this.$parent.year = year;
      this.$parent.dateRedirect();
    }
  }
});

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(56);
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Card',
  props: ['title', 'bodyClass', 'noHeader', 'additionClassName']
});

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(530)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(557),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'layout',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//


var d3 = __webpack_require__(55);
var c3 = __webpack_require__(11);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'statsBrand',
  data: function data() {
    return {
      vG2l: 1,
      vG2r: 1,
      vG3l: 1,
      vG3r: 1,
      vG4l: 1,
      vG4r: 1,
      settings: 0,
      loaderSb: 0,
      yearslist: [],
      names: {
        hatg: '',
        atg: '',
        brand: ''
      },
      categories: [],
      subcategories: [],
      brands: [],
      brandyear: '',
      sort: 'revenues',
      showAll: 0,
      colors: ['hggh', 'hghghghghg', 'nbcnb', 'nbcnb', 'cvbnvcnc'],
      chartData: [["Jan", 4], ["Feb", 2], ["Mar", 10], ["Apr", 5], ["May", 3]],
      chartData1: [["Jan", 4], ["Feb", 2], ["Mar", 10], ["Apr", 5], ["May", 3]],
      showmore: 0
    };
  },

  mounted: function mounted() {
    this.fetchData();

    if (!this.$route.params.brandyear) {
      var date = new Date();
      this.brandyear = date.getFullYear();
    } else {
      this.brandyear = this.$route.params.brandyear;
    }
  },
  watch: {
    $route: function $route() {
      this.brandyear = this.$route.params.brandyear;
      this.fetchData();
      this.showmore = 0;
    }
    //user () {
    //  this.user = this.$parent.$parent.$parent.user
    //}

  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.loaderSb = true;
      if (!this.$route.params.brandyear) {
        var url = 'https://crm.hennig-fahrzeugteile.de:17120/statistik/jahresumsaetze/kunde/' + localStorage.getItem('ext-kunde');
        var headers = {
          'Access-Control-Allow-Origin': '*',
          'Accept': 'application/json',
          'app-version': '2.2',
          'token': localStorage.getItem('ext-token')
        };
        var options = {
          headers: headers
        };
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url + '?token=' + localStorage.getItem('ext-token') + '&sort=' + this.sort + '&jahr=' + this.brandyear, options).then(function (response) {
          /*
          this.years = response.data;
          */
          _this.loaderSb = false;
          /*
          this.checkMorris('year-charts');
          */
          _this.setYears(response.data);
          _this.drawCustomerGraph();
        }).catch(function (e) {
          //console.log(e)
        });
      }
      if (this.$route.params.brandyear && !this.$route.params.brandbrand) {
        var url = 'https://crm.hennig-fahrzeugteile.de:17120/statistik/umsatz/marken/kunde/' + localStorage.getItem('ext-kunde');
        var _headers = {
          'Access-Control-Allow-Origin': '*',
          'Accept': 'application/json',
          'app-version': '2.2',
          'token': localStorage.getItem('ext-token')
        };
        var _options = {
          headers: _headers
        };
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url + '?token=' + localStorage.getItem('ext-token') + '&sort=' + this.sort + '&jahr=' + this.brandyear, _options).then(function (response) {
          _this.brands = response.data;
          _this.loaderSb = false;
          /*
          this.checkMorris('year-charts');
          */
          _this.vG2l = 1;
          _this.vG2r = 1;
          //this.drawGraph(1,'vG2l',response.data)
          _this.drawGraph(2, 'vG2r', response.data);
          _this.setYears(response.data);
        }).catch(function (e) {
          //console.log(e)
        });
      }
      if (this.$route.params.brandyear && this.$route.params.brandbrand && !this.$route.params.brandscat) {
        var url = 'https://crm.hennig-fahrzeugteile.de:17120/statistik/umsatz/marken/kunde/' + localStorage.getItem('ext-kunde');
        var _headers2 = {
          'Access-Control-Allow-Origin': '*',
          'Accept': 'application/json',
          'app-version': '2.2',
          'token': localStorage.getItem('ext-token')
        };
        var _options2 = {
          headers: _headers2
        };
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url + '?token=' + localStorage.getItem('ext-token') + '&sort=' + this.sort + '&jahr=' + this.brandyear, _options2).then(function (response) {
          _this.subcategories = response.data;
          _this.loaderSb = false;
          /*
          this.checkMorris('year-charts');
          */
          _this.vG3l = 1;
          _this.vG3r = 1;
          //this.drawGraph(1,'vG2l',response.data)
          _this.drawGraph(2, 'vG3r', response.data);
          _this.setYears(response.data);
        }).catch(function (e) {
          //console.log(e)
        });
      }
    },
    drawGraph: function drawGraph(id, prop, datas) {

      var dataLj = [[datas[0].id, datas[1].id, datas[2].id, datas[3].id, datas[4].id], [datas[0].name, datas[1].name, datas[2].name, datas[3].name, datas[4].name], [datas[0].umsatzLj, datas[1].umsatzLj, datas[2].umsatzLj, datas[3].umsatzLj, datas[4].umsatzLj], [datas[0].umsatzVj, datas[1].umsatzVj, datas[2].umsatzVj, datas[3].umsatzVj, datas[4].umsatzVj]];

      //console.log(dataLj)

      var sortedVj = this._.sortBy(datas, ['umsatzVj']);
      var dataVj = [[sortedVj[0].id, sortedVj[1].id, sortedVj[2].id, sortedVj[3].id, sortedVj[4].id], [sortedVj[0].name, sortedVj[1].name, sortedVj[2].name, sortedVj[3].name, sortedVj[4].name], [sortedVj[0].umsatzVj, sortedVj[1].umsatzVj, sortedVj[2].umsatzVj, sortedVj[3].umsatzVj, sortedVj[4].umsatzVj]];

      var greys = ['#878787', '#9d9d9c', '#b2b2b2', '#dadada', '#ededed'];
      var colors = ['#003366', '#1d71b8', '#00a19a', '#66aa66', '#006633'];
      var mixed = [];

      //console.log( this._.intersection(dataLj, dataVj) )

      console.log(dataLj[1]);
      console.log(dataVj[1]);

      if (id == 1) {
        var tmpGreys = [],
            tmpColors = [];

        for (var i = 0; i < dataLj[1].length; i++) {
          //console.log( dataLj[0][i] )
          var res = this._.findIndex(dataLj[1], function (o) {
            return o == dataVj[1][i];
          });

          if (res != -1) {
            // gefunden
            //console.log('gefunden')
            mixed.push(colors[i]);
          } else {
            // nicht gefunden
            //console.log('nicht gefunden')
            mixed.push(greys[i]);
          }
        }

        //console.log(mixed)

        /*var tmpColors = [];
        tmpColors.push('red')
        tmpColors.push('green')
        tmpColors.push('blue')
        tmpColors.push('yellow')
        tmpColors.push('purple')*/

        var data = dataVj[2];
        var color = d3.scaleOrdinal(mixed);
      } else {
        var data = dataLj[2];
        var color = d3.scaleOrdinal(colors);
      }

      var pie_chart = c3.generate({
        bindto: "#" + prop + '-' + id,
        size: { width: 300, height: 300 },
        color: {
          pattern: colors
        },
        data: {
          columns: [[dataLj[1][0], dataLj[2][0]], [dataLj[1][1], dataLj[2][1]], [dataLj[1][2], dataLj[2][2]], [dataLj[1][3], dataLj[2][3]], [dataLj[1][4], dataLj[2][4]]],
          type: 'pie'
        }
      });

      /*
      $("#" + prop + '-' + id).find('g').remove()
        var svg = d3.select("#" + prop + '-' + id),
          width = svg.attr("width"),
          height = svg.attr("height"),
          radius = Math.min(width, height) / 2,
          g = svg.append("g").attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");
        // Generate the pie
      var pie = d3.pie();
        // Generate the arcs
      var arc = d3.arc()
                  .innerRadius(0)
                  .outerRadius(radius);
        //Generate groups
      var arcs = g.selectAll("arc")
                  .data(pie(data))
                  .enter()
                  .append("g")
                  .attr("class", "arc")
        //Draw arc paths
      arcs.append("path")
          .attr("fill", function(d, i) {
              return color(i);
          })
          .attr("d", arc);
          */
    },
    drawCustomerGraph: function drawCustomerGraph() {
      var chart = c3.generate({
        bindto: '#chartBrCustomer',
        size: {
          height: 240
        },
        padding: {
          //top: 40,
          //right: 30,
          //bottom: 40,
          //left: 100,
        },
        color: {
          pattern: ['blue', 'green']
        },
        data: {
          x: 'x',
          xFormat: '%Y', // 'xFormat' can be used as custom format of 'x'
          columns: [['x', '2014', '2015', '2016', '2017'],
          //            ['x', '20130101', '20130102', '20130103', '20130104', '20130105', '20130106'],
          ['Umsatz', this.yearslist[0][3].umsatz, this.yearslist[0][2].umsatz, this.yearslist[0][1].umsatz, this.yearslist[0][0].umsatz], ['Erloes', this.yearslist[0][3].erloes, this.yearslist[0][2].erloes, this.yearslist[0][1].erloes, this.yearslist[0][0].erloes]]
        },
        axis: {
          x: {
            type: 'timeseries',
            tick: {
              format: '%Y'
            }
          }
        }
      });
    },
    setYears: function setYears(data) {
      var ret = [];
      var retReversed = [];
      for (var i = 0; i < data.length; i++) {
        ret[i] = data[i];
        retReversed[i] = data[i];
      }
      retReversed = retReversed.reverse();
      this.yearslist.push(ret);
      this.yearslist.push(retReversed);
    },
    setBrandYear: function setBrandYear(year) {
      this.brandyear = year;
      this.fetchData();
    },
    closeSettings: function closeSettings() {
      this.settings = false;
    },
    getRandomArbitrary: function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    },
    setBrandName: function setBrandName(type, value) {
      if (type == 'hatg') {
        this.names.hatg = value;
      }
      if (type == 'atg') {
        this.names.atg = value;
      }
      if (type == 'brand') {
        this.names.brand = value;
      }
    }
  }
});

/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//


var d3 = __webpack_require__(55);
var c3 = __webpack_require__(11);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'statsMaincategory',
  data: function data() {
    return {
      vG2l: 1,
      vG2r: 1,
      vG3l: 1,
      vG3r: 1,
      vG4l: 1,
      vG4r: 1,
      settings: 0,
      loaderSm: 0,
      yearslist: [],
      names: {
        hatg: '',
        atg: '',
        brand: ''
      },
      categories: [],
      subcategories: [],
      brands: [],
      year: '',
      sort: 'revenues',
      showAll: 0,
      colors: ['hggh', 'hghghghghg', 'nbcnb', 'nbcnb', 'cvbnvcnc'],
      chartData: [["Jan", 4], ["Feb", 2], ["Mar", 10], ["Apr", 5], ["May", 3]],
      chartData1: [["Jan", 4], ["Feb", 2], ["Mar", 10], ["Apr", 5], ["May", 3]],
      showmore: 0
    };
  },

  mounted: function mounted() {
    this.fetchData();

    if (!this.$route.params.year) {
      var date = new Date();
      this.year = date.getFullYear();
    } else {
      this.year = this.$route.params.year;
    }
  },
  watch: {
    $route: function $route() {
      this.year = this.$route.params.year;
      this.fetchData();
      this.showmore = 0;
    }
    //user () {
    //  this.user = this.$parent.$parent.$parent.user
    //}

  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.loaderSm = true;
      if (!this.$route.params.year) {
        var url = 'https://crm.hennig-fahrzeugteile.de:17120/statistik/jahresumsaetze/kunde/' + localStorage.getItem('ext-kunde');
        var headers = {
          'Access-Control-Allow-Origin': '*',
          'Accept': 'application/json',
          'app-version': '2.2',
          'token': localStorage.getItem('ext-token')
        };
        var options = {
          headers: headers
        };
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url + '?token=' + localStorage.getItem('ext-token') + '&sort=' + this.sort + '&jahr=' + this.year, options).then(function (response) {
          /*
          this.years = response.data;
          */
          _this.loaderSm = false;
          /*
          this.checkMorris('year-charts');
          */
          _this.setYears(response.data);
          _this.drawCustomerGraph();
        }).catch(function (e) {
          //console.log(e)
        });
      }
      if (this.$route.params.year && !this.$route.params.cat) {
        var url = 'https://crm.hennig-fahrzeugteile.de:17120/statistik/umsatz/hatg/kunde/' + localStorage.getItem('ext-kunde');
        var _headers = { 'Access-Control-Allow-Origin': '*', 'Accept': 'application/json', 'app-version': '2.2', 'token': localStorage.getItem('ext-token') };
        var _options = { headers: _headers };
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url + '?token=' + localStorage.getItem('ext-token') + '&sort=' + this.sort + '&jahr=' + this.year, _options).then(function (response) {
          _this.categories = response.data;
          _this.loaderSm = false;
          /*
          this.checkMorris('category-charts');
          */
          _this.vG2l = 1;
          _this.vG2r = 1;
          //this.drawGraph(1,'vG2l',response.data)
          _this.drawGraph(2, 'vG2r', response.data);
        }).catch(function (e) {
          //console.log(e)
        });
      }

      if (this.$route.params.year && this.$route.params.cat && !this.$route.params.scat) {
        var url = 'https://crm.hennig-fahrzeugteile.de:17120/statistik/umsatz/hatg/kunde/' + localStorage.getItem('ext-kunde') + '/hatg/' + this.$route.params.cat;
        var _headers2 = { 'Access-Control-Allow-Origin': '*', 'Accept': 'application/json', 'app-version': '2.2', 'token': localStorage.getItem('ext-token') };
        var _options2 = { headers: _headers2 };
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url + '?token=' + localStorage.getItem('ext-token') + '&sort=' + this.sort + '&jahr=' + this.year, _options2).then(function (response) {
          _this.subcategories = response.data;
          _this.loaderSm = false;
          /*
          this.checkMorris('subcategory-charts');
          */
          _this.vG3l = 1;
          _this.vG3r = 1;
          //this.drawGraph(1,'vG3l',response.data)
          _this.drawGraph(2, 'vG3r', response.data);
        }).catch(function (e) {
          //console.log(e)
        });
      }

      if (this.$route.params.year && this.$route.params.cat && this.$route.params.scat) {
        var url = 'https://crm.hennig-fahrzeugteile.de:17120/statistik/umsatz/hatg/kunde/' + localStorage.getItem('ext-kunde') + '/hatg/' + this.$route.params.cat + '/atg/' + this.$route.params.scat;
        var _headers3 = { 'Access-Control-Allow-Origin': '*', 'Accept': 'application/json', 'app-version': '2.2', 'token': localStorage.getItem('ext-token') };
        var _options3 = { headers: _headers3 };
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url + '?token=' + localStorage.getItem('ext-token') + '&sort=' + this.sort + '&jahr=' + this.year, _options3).then(function (response) {
          _this.brands = response.data;
          _this.loaderSm = false;
          /*
          this.checkMorris('brand-charts');
          */
          _this.vG4l = 1;
          _this.vG4r = 1;
          //this.drawGraph(1,'vG4l',response.data)
          _this.drawGraph(2, 'vG4r', response.data);
        }).catch(function (e) {
          //console.log(e)
        });
      }
    },
    drawGraph: function drawGraph(id, prop, datas) {

      var dataLj = [[datas[0].id, datas[1].id, datas[2].id, datas[3].id, datas[4].id], [datas[0].name, datas[1].name, datas[2].name, datas[3].name, datas[4].name], [datas[0].umsatzLj, datas[1].umsatzLj, datas[2].umsatzLj, datas[3].umsatzLj, datas[4].umsatzLj], [datas[0].umsatzVj, datas[1].umsatzVj, datas[2].umsatzVj, datas[3].umsatzVj, datas[4].umsatzVj]];

      //console.log(dataLj)

      var sortedVj = this._.sortBy(datas, ['umsatzVj']);
      var dataVj = [[sortedVj[0].id, sortedVj[1].id, sortedVj[2].id, sortedVj[3].id, sortedVj[4].id], [sortedVj[0].name, sortedVj[1].name, sortedVj[2].name, sortedVj[3].name, sortedVj[4].name], [sortedVj[0].umsatzVj, sortedVj[1].umsatzVj, sortedVj[2].umsatzVj, sortedVj[3].umsatzVj, sortedVj[4].umsatzVj]];

      var greys = ['#878787', '#9d9d9c', '#b2b2b2', '#dadada', '#ededed'];
      var colors = ['#003366', '#1d71b8', '#00a19a', '#66aa66', '#006633'];
      var mixed = [];

      //console.log( this._.intersection(dataLj, dataVj) )

      console.log(dataLj[1]);
      console.log(dataVj[1]);

      if (id == 1) {
        var tmpGreys = [],
            tmpColors = [];

        for (var i = 0; i < dataLj[1].length; i++) {
          //console.log( dataLj[0][i] )
          var res = this._.findIndex(dataLj[1], function (o) {
            return o == dataVj[1][i];
          });

          if (res != -1) {
            // gefunden
            //console.log('gefunden')
            mixed.push(colors[i]);
          } else {
            // nicht gefunden
            //console.log('nicht gefunden')
            mixed.push(greys[i]);
          }
        }

        //console.log(mixed)

        /*var tmpColors = [];
        tmpColors.push('red')
        tmpColors.push('green')
        tmpColors.push('blue')
        tmpColors.push('yellow')
        tmpColors.push('purple')*/

        var data = dataVj[2];
        var color = d3.scaleOrdinal(mixed);
      } else {
        var data = dataLj[2];
        var color = d3.scaleOrdinal(colors);
      }

      var pie_chart = c3.generate({
        bindto: "#" + prop + '-' + id,
        size: { width: 300, height: 300 },
        color: {
          pattern: colors
        },
        data: {
          columns: [[dataLj[1][0], dataLj[2][0]], [dataLj[1][1], dataLj[2][1]], [dataLj[1][2], dataLj[2][2]], [dataLj[1][3], dataLj[2][3]], [dataLj[1][4], dataLj[2][4]]],
          type: 'pie'
        }
      });

      /*
      $("#" + prop + '-' + id).find('g').remove()
        var svg = d3.select("#" + prop + '-' + id),
          width = svg.attr("width"),
          height = svg.attr("height"),
          radius = Math.min(width, height) / 2,
          g = svg.append("g").attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");
        // Generate the pie
      var pie = d3.pie();
        // Generate the arcs
      var arc = d3.arc()
                  .innerRadius(0)
                  .outerRadius(radius);
        //Generate groups
      var arcs = g.selectAll("arc")
                  .data(pie(data))
                  .enter()
                  .append("g")
                  .attr("class", "arc")
        //Draw arc paths
      arcs.append("path")
          .attr("fill", function(d, i) {
              return color(i);
          })
          .attr("d", arc);  
          */
    },
    drawCustomerGraph: function drawCustomerGraph() {
      console.log(this.yearslist[0][0].umsatz);
      var chart = c3.generate({
        bindto: '#chartHkCustomer',
        size: {
          height: 240
        },
        padding: {
          //top: 40,
          //right: 30,
          //bottom: 40,
          //left: 100,
        },
        color: {
          pattern: ['blue', 'green']
        },
        data: {
          x: 'x',
          xFormat: '%Y', // 'xFormat' can be used as custom format of 'x'
          columns: [['x', '2014', '2015', '2016', '2017'],
          //            ['x', '20130101', '20130102', '20130103', '20130104', '20130105', '20130106'],
          ['Umsatz', this.yearslist[0][3].umsatz, this.yearslist[0][2].umsatz, this.yearslist[0][1].umsatz, this.yearslist[0][0].umsatz], ['Erloes', this.yearslist[0][3].erloes, this.yearslist[0][2].erloes, this.yearslist[0][1].erloes, this.yearslist[0][0].erloes]]
        },
        axis: {
          x: {
            type: 'timeseries',
            tick: {
              format: '%Y'
            }
          }
        }
      });
    },
    setYears: function setYears(data) {
      var ret = [];
      var retReversed = [];
      for (var i = 0; i < data.length; i++) {
        ret[i] = data[i];
        retReversed[i] = data[i];
      }
      retReversed = retReversed.reverse();
      this.yearslist.push(ret);
      this.yearslist.push(retReversed);
    },
    setYear: function setYear(year) {
      this.year = year;
      this.fetchData();
    },
    closeSettings: function closeSettings() {
      this.settings = false;
    },
    getRandomArbitrary: function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    },
    setName: function setName(type, value) {
      if (type == 'hatg') {
        this.names.hatg = value;
      }
      if (type == 'atg') {
        this.names.atg = value;
      }
      if (type == 'brand') {
        this.names.brand = value;
      }
    }
  }
});

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lodash_dist_vue_lodash_min__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lodash_dist_vue_lodash_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_lodash_dist_vue_lodash_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Elements_Card_Card_vue__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Elements_Card_Card_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Elements_Card_Card_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_chartkick__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_chartkick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_chartkick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_chartkick__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_chartkick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_chartkick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_highcharts__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_highcharts__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_lodash_dist_vue_lodash_min___default.a, __WEBPACK_IMPORTED_MODULE_3_lodash___default.a);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Card', __WEBPACK_IMPORTED_MODULE_5__components_Elements_Card_Card_vue___default.a);





window.Highcharts = __WEBPACK_IMPORTED_MODULE_8_highcharts___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_chartkick___default.a, { Chartkick: __WEBPACK_IMPORTED_MODULE_6_chartkick___default.a });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

try {
    window.$ = window.jQuery = __webpack_require__(193);
    __webpack_require__(189);
} catch (e) {}

__webpack_require__(191).polyfill();
//require('font-awesome/css/font-awesome.css')

var numeral = __webpack_require__(195);

numeral.register('locale', 'de', {
    delimiters: {
        thousands: '.',
        decimal: ','
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
    },
    ordinal: function ordinal(number) {
        return number;
    },
    currency: {
        symbol: '€'
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('myCurrency', function (value) {
    numeral.locale('de');
    return numeral(value).format();
});

// Some Config
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$serviceurl = 'https://crm.hennig-fahrzeugteile.de:16120/';

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(236)(undefined);
// imports


// module
exports.push([module.i, ".card{width:100%;background-color:#fff;border-radius:3px;-webkit-box-shadow:0 1px 2px #c8d1d3;box-shadow:0 1px 2px #c8d1d3}.card .card-header{padding:30px;font-size:1.1em;font-weight:400;border-bottom:1px solid #dfe6e8;border-left:0 solid transparent;color:#666;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.card .card-header .card-title{-webkit-box-flex:1;-ms-flex:1;flex:1}.card .card-header .card-action{list-style:none;margin:0;padding:0}.card .card-header .card-action>li>a{color:#dfe6e8}.card .card-header .card-action>li>.dropdown-menu{right:0;left:auto;border-radius:2px}.card .card-body{padding:30px}.card.card-mini .card-header{padding:20px 30px}.card.card-mini .card-body{padding:20px 0}.card.card-tab .card-header{padding:0;background-color:#f0f4f5;border-bottom:0;overflow-x:scroll;overflow-y:visible}.card.card-tab .card-header>ul,.card.card-tab ul.nav-tabs{list-style:none;padding:0;margin-bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;width:100%;font-weight:400;border-bottom:1px solid #dfe6e8}.card.card-tab .card-header>ul>li,.card.card-tab ul.nav-tabs>li{display:block;margin-bottom:-2px;z-index:10;width:140px;min-width:140px}.card.card-tab .card-header>ul>li a,.card.card-tab ul.nav-tabs>li a{padding:20px 30px;width:100%;text-align:center;display:block;text-decoration:none;color:#8d9293;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.card.card-tab .card-header>ul>li.active,.card.card-tab ul.nav-tabs>li.active{border-left:1px solid #dfe6e8;border-right:1px solid #dfe6e8;background-color:#fff}.card.card-tab .card-header>ul>li.active a,.card.card-tab ul.nav-tabs>li.active a{color:#29c75f;border-bottom:none!important}.card.card-tab .card-header>ul>li:first-child.active,.card.card-tab ul.nav-tabs>li:first-child.active{border-left:0}.card.card-tab .tab-content{padding:0;position:relative;-webkit-transition:all .3s ease;transition:all .3s ease}.card.card-tab .tab-content .tab-pane{position:absolute;top:auto;left:auto;bottom:auto;right:auto;width:100%;height:auto;display:none;padding:30px;-webkit-transition:all .3s ease;transition:all .3s ease}.card.card-tab .tab-content .tab-pane.active{-webkit-transform:translate(0);transform:translate(0);position:relative;display:block}.card.card-tab .tab-content .tab-pane{opacity:0}.card.card-tab .tab-content .tab-pane.active{opacity:1}.card.card-tab.card-mini .card-header>li a,.card.card-tab.card-mini ul.nav-tabs>li a{padding-top:20px;padding-bottom:20px}.card.card-banner{width:100%;position:relative;overflow:hidden;display:block;border-radius:2px;-webkit-transition:all .2s ease;transition:all .2s ease}.card.card-banner:hover{cursor:pointer;text-decoration:none}.card.card-banner .card-header{background-color:#fff}.card.card-banner .card-body{padding:0}.card.card-banner .card-body .icon{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);font-size:4em;color:#444;z-index:0;padding:10px;min-height:100%;min-width:100px;-webkit-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.card.card-banner .card-body .content,.card.card-banner .card-body .icon{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.card.card-banner .card-body .content{-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;position:relative;width:100%;padding:2rem;z-index:100}.card.card-banner .card-body .content .value{font-size:4em;line-height:3rem;font-weight:200;padding-top:2rem;color:#444}.card.card-banner .card-body .content .value .sign{font-size:.4em;font-weight:200;margin-right:5px;opacity:.75}.card.card-banner .card-body .content .title{font-size:1em;font-weight:400;color:#8d9293;text-transform:uppercase}.card.card-banner .card-body:after{content:\"\";position:relative;display:block;clear:both}.card.card-chart .card-header{border-bottom:0}.card.card-chart .card-header .card-title .title{background-color:#fff;padding:6px 12px;border-radius:2px;font-weight:400;width:auto;display:inline;text-transform:uppercase}.card.card-green{background-color:#29c75f}.card.card-green .card-body .icon{color:#fff;background-color:hsla(0,0%,100%,.05)}.card.card-green .card-body .content .value{color:#fff}.card.card-green-light{background-color:#fff}.card.card-green-light .card-body .icon{color:#29c75f;background-color:rgba(41,199,95,.05)}.card.card-green-light .card-body .content .value{color:#29c75f}.card.card-green-light:hover{background-color:#29c75f}.card.card-green-light:hover .card-body .icon{color:#fff;background-color:hsla(0,0%,100%,.1)}.card.card-green-light:hover .card-body .content .title,.card.card-green-light:hover .card-body .content .value{color:#fff}.card.card-green.card-chart .card-header{background-color:#29c75f;color:#29c75f}.card.card-blue{background-color:#39c3da}.card.card-blue .card-body .icon{color:#fff;background-color:hsla(0,0%,100%,.05)}.card.card-blue .card-body .content .value{color:#fff}.card.card-blue-light{background-color:#fff}.card.card-blue-light .card-body .icon{color:#39c3da;background-color:rgba(57,195,218,.05)}.card.card-blue-light .card-body .content .value{color:#39c3da}.card.card-blue-light:hover{background-color:#39c3da}.card.card-blue-light:hover .card-body .icon{color:#fff;background-color:hsla(0,0%,100%,.1)}.card.card-blue-light:hover .card-body .content .title,.card.card-blue-light:hover .card-body .content .value{color:#fff}.card.card-blue.card-chart .card-header{background-color:#39c3da;color:#39c3da}.card.card-orange{background-color:#fc8229}.card.card-orange .card-body .icon{color:#fff;background-color:hsla(0,0%,100%,.05)}.card.card-orange .card-body .content .value{color:#fff}.card.card-orange-light{background-color:#fff}.card.card-orange-light .card-body .icon{color:#fc8229;background-color:rgba(252,130,41,.05)}.card.card-orange-light .card-body .content .value{color:#fc8229}.card.card-orange-light:hover{background-color:#fc8229}.card.card-orange-light:hover .card-body .icon{color:#fff;background-color:hsla(0,0%,100%,.1)}.card.card-orange-light:hover .card-body .content .title,.card.card-orange-light:hover .card-body .content .value{color:#fff}.card.card-orange.card-chart .card-header{background-color:#fc8229;color:#fc8229}.card.card-yellow{background-color:#ffbc11}.card.card-yellow .card-body .icon{color:#fff;background-color:hsla(0,0%,100%,.05)}.card.card-yellow .card-body .content .value{color:#fff}.card.card-yellow-light{background-color:#fff}.card.card-yellow-light .card-body .icon{color:#ffbc11;background-color:rgba(255,188,17,.05)}.card.card-yellow-light .card-body .content .value{color:#ffbc11}.card.card-yellow-light:hover{background-color:#ffbc11}.card.card-yellow-light:hover .card-body .icon{color:#fff;background-color:hsla(0,0%,100%,.1)}.card.card-yellow-light:hover .card-body .content .title,.card.card-yellow-light:hover .card-body .content .value{color:#fff}.card.card-yellow.card-chart .card-header{background-color:#ffbc11;color:#ffbc11}@media (max-width:767px){.card .card-body,.card .card-header,.card.card-mini .card-body,.card.card-mini .card-header{padding:15px}.card.card-tab .card-body,.card.card-tab .card-header{padding:0}.card.card-tab .tab-content .tab-pane{padding:15px}.card.card-tab.card-mini .card-header>li a,.card.card-tab.card-mini ul.nav-tabs>li a{padding-top:15px;padding-bottom:15px}.card.card-banner .card-body .icon{font-size:3em;min-width:80px}.card.card-banner .card-body .content{padding:1rem}.card.card-banner .card-body .content .value{font-size:3em;padding-top:1rem}.card.card-banner .card-body .content .title{font-size:.9em}}.card{border-radius:0;-webkit-box-shadow:none;box-shadow:none}", ""]);

// exports


/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(552),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 526:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 527:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 528:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 529:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 530:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 531:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 532:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 533:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 535:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 536:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 537:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 538:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 539:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(532)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(559),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(528)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(555),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(529)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(556),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(533)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(560),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(539)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(568),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(527)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(554),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(531)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(558),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(535)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(562),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(536)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(564),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-569c6ad1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(526)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(553),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(538)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(567),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 552:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "date text-center"
  }, _vm._l((_vm.years), function(item, index) {
    return _c('a', {
      key: index,
      staticClass: "link",
      class: {
        active: _vm.$route.params.year == item.jahr
      },
      on: {
        "click": function($event) {
          _vm.setYear(item.jahr)
        }
      }
    }, [_vm._v("\r\n            " + _vm._s(item.jahr) + "\r\n        ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\r\n        Aktueller Vergleich: " + _vm._s(_vm.period == 'vormonat' || _vm.period == '' ? 'Periode' : 'Ganzes Jahr') + "\r\n    ")])])
},staticRenderFns: []}

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "statsBrand"
  }, [(_vm.settings) ? _c('div', {
    staticClass: "settings"
  }, [_c('div', {
    staticClass: "link text-right closeBtn",
    on: {
      "click": function($event) {
        _vm.closeSettings();
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('p', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.sort = '';
        _vm.fetchData();
        _vm.closeSettings();
      }
    }
  }, [_vm._v("Alle anzeigen")]), _vm._v(" "), _c('p', {
    staticClass: "divider"
  }, [_vm._v("Sortieren")]), _vm._v(" "), _c('p', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.sort = 'alpha';
        _vm.fetchData();
        _vm.closeSettings();
      }
    }
  }, [_vm._v("Alphabetisch")]), _vm._v(" "), _c('p', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.sort = 'revenues';
        _vm.fetchData();
        _vm.closeSettings();
      }
    }
  }, [_vm._v("Nach Umsatz")])]) : _vm._e(), _vm._v(" "), (_vm.loaderSb) ? _c('div', {
    staticClass: "loader-wrapper-sb"
  }) : _vm._e(), _vm._v(" "), (_vm.loaderSb) ? _c('div', {
    staticClass: "loader-sb"
  }) : _vm._e(), _vm._v(" "), (!_vm.$route.params.brandyear) ? _c('card', {
    attrs: {
      "addition-class-name": "card-mini",
      "body-class": "no-padding table-responsiveXX"
    }
  }, [_c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "chartWrapper"
  }, [_c('div', {
    staticClass: "chart col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right"
  }, [_c('div', {
    attrs: {
      "id": "chartBrCustomer"
    }
  })])])])]), _vm._v(" "), _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.yearslist[0]), function(year, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'dsby',
          params: {
            brandyear: year.jahr
          }
        }
      }
    }, [_c('td', [_vm._v(_vm._s(year.jahr) + " "), _c('span', {
      staticClass: "label label-primary"
    }, [_vm._v("GS: " + _vm._s(year.gewinnSpanne) + " | WB: " + _vm._s(year.webQuote))])]), _vm._v(" "), _c('td', [_vm._v("\r\n                            " + _vm._s(_vm._f("myCurrency")(year.umsatz)) + " €\r\n                        ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.$route.params.brandyear && !_vm.$route.params.brandbrand) ? _c('card', {
    attrs: {
      "title": "Marken Statistik",
      "addition-class-name": "card-mini",
      "body-class": "no-padding table-responsiveXX"
    }
  }, [_c('router-link', {
    staticClass: "back",
    attrs: {
      "tag": "div",
      "to": "/dashboard/stats/brands"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "settingsOpener",
    on: {
      "click": function($event) {
        _vm.settings = !_vm.settings
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  })]), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chartWrapper"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), (_vm.sort == 'revenues') ? _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "200px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.vG2r == 1) ? _c('svg', {
    attrs: {
      "id": "vG2r-2",
      "width": "300",
      "height": "300"
    }
  }) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "names"
  }, [_c('span', {
    staticClass: "title-one"
  }, [_vm._v("Marken")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "title-two"
  }, [_vm._v("Alle")])])]), _vm._v(" "), _c('div', {
    staticClass: "date text-center"
  }, _vm._l((_vm.yearslist[1]), function(item, index) {
    return _c('router-link', {
      key: index,
      class: {
        active: _vm.$route.params.brandyear == item.jahr
      },
      attrs: {
        "to": {
          name: 'dsby',
          params: {
            brandyear: item.jahr
          }
        }
      },
      on: {
        "click": function($event) {
          _vm.setBrandYear(item.jahr)
        }
      }
    }, [_vm._v("\r\n                    " + _vm._s(item.jahr) + "\r\n                ")])
  })), _vm._v(" "), (_vm.sort == 'revenues') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', [_vm._l((_vm.brands), function(brand, index) {
    return (index < 5) ? _c('router-link', {
      key: brand.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'dsbb',
          params: {
            brandyear: _vm.$route.params.brandyear,
            brandbrand: brand.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setBrandName('hatg', brand.name)
        }
      }
    }, [_c('td', {
      staticClass: "colorPill"
    }, [_c('span', {
      staticClass: "colorPill"
    }), _vm._v(_vm._s(brand.name))]), _vm._v(" "), _c('td', [(brand.umsatzVj > 0) ? _c('span', [(brand.umsatzLj > brand.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_c('br'), _vm._v("(" + _vm._s(brand.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward"
    }, [_c('br'), _vm._v("(" + _vm._s(brand.umsatzDiff) + "%)")])]) : _vm._e(), _vm._v(_vm._s(_vm._f("myCurrency")(brand.umsatzLj)) + " €"), _c('br'), (brand.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(brand.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])]) : _vm._e()
  }), _vm._v(" "), (_vm.brands.length > 5) ? _c('tr', {
    on: {
      "click": function($event) {
        _vm.showmore = !_vm.showmore
      }
    }
  }, [_c('td', [_vm._v("\r\n                            Andere\r\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                            " + _vm._s(_vm._f("myCurrency")(4678956)) + " €\r\n                        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {
    staticClass: "next"
  })])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showmore && _vm.sort == 'revenues') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.brands), function(brand, index) {
    return (index >= 5) ? _c('router-link', {
      key: brand.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'dsbb',
          params: {
            brandyear: _vm.$route.params.brandyear,
            brandbrand: brand.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setBrandName('hatg', brand.name)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(brand.name))]), _vm._v(" "), _c('td', [(brand.umsatzVj > 0) ? _c('span', [(brand.umsatzLj > brand.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_c('br'), _vm._v("(" + _vm._s(brand.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward"
    }, [_c('br'), _vm._v("(" + _vm._s(brand.umsatzDiff) + "%)")])]) : _vm._e(), _vm._v(_vm._s(_vm._f("myCurrency")(brand.umsatzLj)) + " €"), _c('br'), (brand.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(brand.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])]) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), (_vm.sort != 'revenues') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.brands), function(brand, index) {
    return _c('router-link', {
      key: brand.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'dsbb',
          params: {
            brandyear: _vm.$route.params.brandyear,
            brandbrand: brand.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setBrandName('hatg', brand.name)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(brand.name))]), _vm._v(" "), _c('td', [(brand.umsatzVj > 0) ? _c('span', [(brand.umsatzLj > brand.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_c('br'), _vm._v("(" + _vm._s(brand.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward"
    }, [_c('br'), _vm._v("(" + _vm._s(brand.umsatzDiff) + "%)")])]) : _vm._e(), _vm._v(_vm._s(_vm._f("myCurrency")(brand.umsatzLj)) + " €"), _c('br'), (brand.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(brand.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])])
  }))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.brandyear && _vm.$route.params.brandbrand) ? _c('card', {
    attrs: {
      "title": "Marken Statistik",
      "addition-class-name": "card-mini",
      "body-class": "no-padding table-responsiveXX"
    }
  }, [_c('router-link', {
    staticClass: "back",
    attrs: {
      "tag": "div",
      "to": {
        name: 'dsby',
        params: {
          brandyear: _vm.$route.params.brandyear
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "settingsOpener",
    on: {
      "click": function($event) {
        _vm.settings = !_vm.settings
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  })]), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chartWrapper"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), (_vm.sort == 'revenues') ? _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "200px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.vG3r == 1) ? _c('svg', {
    attrs: {
      "id": "vG3r-2",
      "width": "300",
      "height": "300"
    }
  }) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "names"
  }, [_c('span', {
    staticClass: "title-one"
  }, [_vm._v(_vm._s(_vm.names.hatg))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "title-two"
  }, [_vm._v("Artikelgruppen")])])]), _vm._v(" "), _c('div', {
    staticClass: "date text-center"
  }, _vm._l((_vm.yearslist[1]), function(item, index) {
    return _c('router-link', {
      key: index,
      class: {
        active: _vm.$route.params.brandyear == item.jahr
      },
      attrs: {
        "to": {
          name: 'dsbb',
          params: {
            brandyear: item.jahr
          }
        }
      },
      on: {
        "click": function($event) {
          _vm.setBrandYear(item.jahr)
        }
      }
    }, [_vm._v("\r\n                    " + _vm._s(item.jahr) + "\r\n                ")])
  })), _vm._v(" "), (_vm.sort == 'revenues') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', [_vm._l((_vm.subcategories), function(subcategory, index) {
    return (index < 5) ? _c('tr', {
      key: index,
      nativeOn: {
        "click": function($event) {
          _vm.setBrandName('atg', subcategory.name)
        }
      }
    }, [_c('td', {
      staticClass: "colorPill"
    }, [_c('span', {
      staticClass: "colorPill"
    }), _vm._v(_vm._s(subcategory.name))]), _vm._v(" "), _c('td', [(subcategory.umsatzVj > 0) ? _c('span', [(subcategory.umsatzLj > subcategory.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_c('br'), _vm._v("(" + _vm._s(subcategory.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward"
    }, [_c('br'), _vm._v("(" + _vm._s(subcategory.umsatzDiff) + "%)")])]) : _vm._e(), _vm._v(_vm._s(_vm._f("myCurrency")(subcategory.umsatzLj)) + " €"), _c('br'), _vm._v(" "), (subcategory.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(subcategory.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])])]) : _vm._e()
  }), _vm._v(" "), (_vm.subcategories.length > 5) ? _c('tr', {
    on: {
      "click": function($event) {
        _vm.showmore = !_vm.showmore
      }
    }
  }, [_c('td', [_vm._v("\r\n                            Andere\r\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                            " + _vm._s(_vm._f("myCurrency")(4678956)) + " €\r\n                        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {
    staticClass: "next"
  })])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showmore && _vm.sort == 'revenues') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.subcategories), function(subcategory, index) {
    return (index >= 5) ? _c('tr', {
      key: index,
      nativeOn: {
        "click": function($event) {
          _vm.setBrandName('atg', subcategory.name)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(subcategory.name))]), _vm._v(" "), _c('td', [(subcategory.umsatzVj > 0) ? _c('span', [(subcategory.umsatzLj > subcategory.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_c('br'), _vm._v("(" + _vm._s(subcategory.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward"
    }, [_c('br'), _vm._v("(" + _vm._s(subcategory.umsatzDiff) + "%)")])]) : _vm._e(), _vm._v(_vm._s(_vm._f("myCurrency")(subcategory.umsatzLj)) + " €"), _c('br'), _vm._v(" "), (subcategory.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(subcategory.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])])]) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), (_vm.sort != 'revenues') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.subcategories), function(subcategory, index) {
    return _c('tr', {
      key: index,
      nativeOn: {
        "click": function($event) {
          _vm.setBrandName('atg', subcategory.name)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(subcategory.name))]), _vm._v(" "), _c('td', [(subcategory.umsatzVj > 0) ? _c('span', [(subcategory.umsatzLf > subcategory.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_c('br'), _vm._v("(" + _vm._s(subcategory.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward"
    }, [_c('br'), _vm._v("(" + _vm._s(subcategory.umsatzDiff) + "%)")])]) : _vm._e(), _vm._v(_vm._s(_vm._f("myCurrency")(subcategory.umsatzLj)) + " €"), _c('br'), _vm._v(" "), (subcategory.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(subcategory.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])])])
  }))]) : _vm._e()], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 554:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-tabs nav-justified"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'statisticsmc'
      }
    }
  }, [_vm._v("\r\n                Hauptartgrp.\r\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'statisticsb'
      }
    }
  }, [_vm._v("\r\n                Marken\r\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    staticStyle: {
      "padding-bottom": "100px"
    }
  }, [_c('div', {
    staticClass: "tab-pane in active",
    attrs: {
      "id": "hk"
    }
  }, [_c('div', {
    staticClass: "rowX"
  }, [_c('router-view'), _vm._v(" "), (_vm.modus != 'top' && _vm.modus != 'flop') ? _c('searchfield', {
    attrs: {
      "count": _vm.brands.length
    }
  }) : _vm._e(), _vm._v(" "), _c('back', {
    attrs: {
      "link": _vm.link
    }
  }), _vm._v(" "), _c('settings'), _vm._v(" "), _c('div', {
    staticClass: "names",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('span', {
    staticClass: "title-one"
  }, [_vm._v(_vm._s(_vm.$parent.names.atg))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "title-two"
  }, [_vm._v("Marken")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showUE == 1) ? _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary active",
    on: {
      "click": function($event) {
        _vm.mode = '1'
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" Umsatz\r\n                        ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.mode = '2'
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option2",
      "autocomplete": "off"
    }
  }), _vm._v(" Erlös\r\n                        ")])]) : _vm._e()]), _vm._v(" "), _c('years', {
    attrs: {
      "years": _vm.years[1],
      "period": _vm.period
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.mode == '1') ? _c('span', [(_vm.modus != '') ? _c('table', {
    staticClass: "table table-colored card-table"
  }, [_c('tbody', [_vm._l((_vm.brands), function(category, index) {
    return _c('tr', {
      key: category.id
    }, [_c('td', {
      staticClass: "colorPill"
    }, [_c('span', {
      staticClass: "colorPill"
    }), _vm._v(" " + _vm._s(category.name) + "\r\n                ")]), _vm._v(" "), _c('td', [(category.umsatzNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                        \r\n                                        (" + _vm._s(category.umsatzDiff) + "%)\r\n                                    ")]) : (category.umsatzLj > category.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                        \r\n                                        (" + _vm._s(category.umsatzDiff) + "%)\r\n                                    ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("  \r\n                                        \r\n                                        (" + _vm._s(category.umsatzDiff) + "%)\r\n                                    ")]), _vm._v("\r\n                    \r\n                    " + _vm._s(_vm._f("myCurrency")(category.umsatzLj)) + " €\r\n                    "), _c('br'), _vm._v(" "), (category.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _vm._m(0, true)])
  }), _vm._v(" "), (_vm.brands.length > 5) ? _c('tr', {
    on: {
      "click": function($event) {
        _vm.showmore = !_vm.showmore
      }
    }
  }, [_c('td', [_vm._v("\r\n                        Andere\r\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                        " + _vm._s(_vm._f("myCurrency")(_vm.sum)) + " €\r\n                    ")]), _vm._v(" "), _vm._m(1)]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showmore && _vm.modus != '') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.brands), function(category, index) {
    return _c('tr', {
      key: category.id
    }, [_c('td', [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('td', [(category.umsatzNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                                \r\n                                                (" + _vm._s(category.umsatzDiff) + "%)\r\n                                            ")]) : (category.umsatzLj > category.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                                \r\n                                                (" + _vm._s(category.umsatzDiff) + "%)\r\n                                            ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("  \r\n                                                \r\n                                                (" + _vm._s(category.umsatzDiff) + "%)\r\n                                            ")]), _vm._v("\r\n                                \r\n                                " + _vm._s(_vm._f("myCurrency")(category.umsatzLj)) + " €\r\n                                "), _c('br'), _vm._v(" "), (category.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _vm._m(2, true)])
  }))]) : _vm._e(), _vm._v(" "), (_vm.modus == '') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.brands), function(category, index) {
    return _c('tr', {
      key: category.id
    }, [_c('td', [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('td', [(category.umsatzNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                                \r\n                                                (" + _vm._s(category.umsatzDiff) + "%)\r\n                                            ")]) : (category.umsatzLj > category.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                                \r\n                                                (" + _vm._s(category.umsatzDiff) + "%)\r\n                                            ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("  \r\n                                                \r\n                                                (" + _vm._s(category.umsatzDiff) + "%)\r\n                                            ")]), _vm._v("\r\n                                \r\n                                " + _vm._s(_vm._f("myCurrency")(category.umsatzLj)) + " €\r\n                                "), _c('br'), _vm._v(" "), (category.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _vm._m(3, true)])
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mode == '2') ? _c('span', [(_vm.modus != '') ? _c('table', {
    staticClass: "table table-colored card-table"
  }, [_c('tbody', [_vm._l((_vm.brands), function(category, index) {
    return _c('tr', {
      key: category.id
    }, [_c('td', {
      staticClass: "colorPill"
    }, [_c('span', {
      staticClass: "colorPill"
    }), _vm._v(" " + _vm._s(category.name) + "\r\n                ")]), _vm._v(" "), _c('td', [(category.erloesNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                        \r\n                                        (" + _vm._s(category.erloesDiff) + "%)\r\n                                    ")]) : (category.erloesLj > category.erloesVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                        \r\n                                        (" + _vm._s(category.erloesDiff) + "%)\r\n                                    ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("  \r\n                                        \r\n                                        (" + _vm._s(category.erloesDiff) + "%)\r\n                                    ")]), _vm._v("\r\n                    \r\n                    " + _vm._s(_vm._f("myCurrency")(category.erloesLj)) + " €\r\n                    "), _c('br'), _vm._v(" "), (category.erloesVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.erloesVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _vm._m(4, true)])
  }), _vm._v(" "), (_vm.brands.length > 5) ? _c('tr', {
    on: {
      "click": function($event) {
        _vm.showmore = !_vm.showmore
      }
    }
  }, [_c('td', [_vm._v("\r\n                        Andere\r\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                        " + _vm._s(_vm._f("myCurrency")(4678956)) + " €\r\n                    ")]), _vm._v(" "), _vm._m(5)]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showmore && _vm.modus != '') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.brands), function(category, index) {
    return _c('tr', {
      key: category.id
    }, [_c('td', [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('td', [(category.erloesNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                                \r\n                                                (" + _vm._s(category.erloesDiff) + "%)\r\n                                            ")]) : (category.erloesLj > category.erloesVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                                \r\n                                                (" + _vm._s(category.erloesDiff) + "%)\r\n                                            ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("  \r\n                                                \r\n                                                (" + _vm._s(category.erloesDiff) + "%)\r\n                                            ")]), _vm._v("\r\n                                \r\n                                " + _vm._s(_vm._f("myCurrency")(category.erloesLj)) + " €\r\n                                "), _c('br'), _vm._v(" "), (category.erloesVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.erloesVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _vm._m(6, true)])
  }))]) : _vm._e(), _vm._v(" "), (_vm.modus == '') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.brands), function(category, index) {
    return _c('tr', {
      key: category.id
    }, [_c('td', [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('td', [(category.erloesNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                                \r\n                                                (" + _vm._s(category.erloesDiff) + "%)\r\n                                            ")]) : (category.erloesLj > category.erloesVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                                \r\n                                                (" + _vm._s(category.erloesDiff) + "%)\r\n                                            ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("  \r\n                                                \r\n                                                (" + _vm._s(category.erloesDiff) + "%)\r\n                                            ")]), _vm._v("\r\n                                \r\n                                " + _vm._s(_vm._f("myCurrency")(category.erloesLj)) + " €\r\n                                "), _c('br'), _vm._v(" "), (category.erloesVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.erloesVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _vm._m(7, true)])
  }))]) : _vm._e()]) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {})])
}]}

/***/ }),

/***/ 555:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-tabs nav-justified"
  }, [_c('li', [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'statisticsmc'
      }
    }
  }, [_vm._v("\r\n                Hauptartgrp.\r\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'statisticsb'
      }
    }
  }, [_vm._v("\r\n                Marken\r\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    staticStyle: {
      "padding-bottom": "100px"
    }
  }, [_c('div', {
    staticClass: "tab-pane in active",
    attrs: {
      "id": "hk"
    }
  }, [_c('div', {
    staticClass: "rowX text-center"
  }, [_c('settings', {
    attrs: {
      "mode": "first"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary active",
    on: {
      "click": function($event) {
        _vm.drawChart()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" Umsatz\r\n                    ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.drawChart(true)
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option2",
      "autocomplete": "off"
    }
  }), _vm._v(" Quoten\r\n                    ")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-colored card-table"
  }, [_c('tbody', _vm._l((_vm.years[0]), function(year, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'statisticsby',
          params: {
            year: year.jahr
          }
        }
      }
    }, [_c('td', [_vm._v(_vm._s(year.jahr))]), _vm._v(" "), _c('td', [_vm._v("\r\n                                " + _vm._s(_vm._f("myCurrency")(year.umsatz)) + " €\r\n                            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])])
  }))])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "chart",
    attrs: {
      "id": "yCustomerChart"
    }
  })])
}]}

/***/ }),

/***/ 556:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-tabs nav-justified"
  }, [_c('li', [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'statisticsmc'
      }
    }
  }, [_vm._v("\r\n                Hauptartgrp.\r\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'statisticsb'
      }
    }
  }, [_vm._v("\r\n                Marken\r\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    staticStyle: {
      "padding-bottom": "100px"
    }
  }, [_c('div', {
    staticClass: "tab-pane in active",
    attrs: {
      "id": "hk"
    }
  }, [_c('div', {
    staticClass: "rowX"
  }, [_c('router-view'), _vm._v(" "), (_vm.modus != 'top' && _vm.modus != 'flop') ? _c('searchfield', {
    attrs: {
      "count": _vm.atgs.length
    }
  }) : _vm._e(), _vm._v(" "), _c('back', {
    attrs: {
      "link": _vm.link
    }
  }), _vm._v(" "), _c('settings'), _vm._v(" "), _c('div', {
    staticClass: "names",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('span', {
    staticClass: "title-one"
  }, [_vm._v(_vm._s(_vm.$parent.names.hatg))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "title-two"
  }, [_vm._v("Artikelgruppen")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.showUE == 1) ? _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary active",
    on: {
      "click": function($event) {
        _vm.mode = '1'
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" Umsatz\r\n                        ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.mode = '2'
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option2",
      "autocomplete": "off"
    }
  }), _vm._v(" Erlös\r\n                        ")])]) : _vm._e()]), _vm._v(" "), (_vm.modus != '') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "chart",
    attrs: {
      "id": "yCustomerChart"
    }
  })]) : _vm._e(), _vm._v(" "), _c('years', {
    attrs: {
      "years": _vm.years[1],
      "period": _vm.period
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.modus != '') ? _c('table', {
    staticClass: "table table-colored card-table"
  }, [_c('tbody', [_vm._l((_vm.atgs), function(brand, index) {
    return (index < 5) ? _c('tr', {
      key: index,
      attrs: {
        "tag": "tr"
      }
    }, [_c('td', {
      staticClass: "colorPill"
    }, [_c('span', {
      staticClass: "colorPill"
    }), _vm._v(" " + _vm._s(brand.name) + "\r\n                            ")]), _vm._v(" "), _c('td', [(brand.umsatzNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                                \r\n                                                (" + _vm._s(brand.umsatzDiff) + "%)\r\n                                            ")]) : (brand.umsatzLj > brand.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                        \r\n                                        (" + _vm._s(brand.umsatzDiff) + "%)\r\n                                    ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("\r\n                                        \r\n                                        (" + _vm._s(brand.umsatzDiff) + "%)\r\n                                    ")]), _vm._v(" " + _vm._s(_vm._f("myCurrency")(brand.umsatzLj)) + " €\r\n                                "), _c('br'), _vm._v(" "), (brand.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(brand.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _vm._m(0, true)]) : _vm._e()
  }), _vm._v(" "), (_vm.atgs.length > 5) ? _c('tr', {
    on: {
      "click": function($event) {
        _vm.showmore = !_vm.showmore
      }
    }
  }, [_c('td', [_vm._v("\r\n                                Andere\r\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                                " + _vm._s(_vm._f("myCurrency")(_vm.sum)) + " €\r\n                            ")]), _vm._v(" "), _vm._m(1)]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showmore && _vm.modus != '') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.atgs), function(brand, index) {
    return (index >= 5) ? _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(brand.name))]), _vm._v(" "), _c('td', [(brand.umsatzNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                                    \r\n                                                    (" + _vm._s(brand.umsatzDiff) + "%)\r\n                                                ")]) : (brand.umsatzLj > brand.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                            \r\n                                            (" + _vm._s(brand.umsatzDiff) + "%)\r\n                                        ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("\r\n                                            \r\n                                            (" + _vm._s(brand.umsatzDiff) + "%)\r\n                                        ")]), _vm._v(" " + _vm._s(_vm._f("myCurrency")(brand.umsatzLj)) + " €\r\n                                "), _c('br'), _vm._v(" "), (brand.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(brand.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _vm._m(2, true)]) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), (_vm.modus == '') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.atgs), function(brand, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(brand.name))]), _vm._v(" "), _c('td', [(brand.umsatzNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                                    \r\n                                                    (" + _vm._s(brand.umsatzDiff) + "%)\r\n                                                ")]) : (brand.umsatzLj > brand.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                            \r\n                                            (" + _vm._s(brand.umsatzDiff) + "%)\r\n                                        ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("\r\n                                            \r\n                                            (" + _vm._s(brand.umsatzDiff) + "%)\r\n                                        ")]), _vm._v(" " + _vm._s(_vm._f("myCurrency")(brand.umsatzLj)) + " €\r\n                                "), _c('br'), _vm._v(" "), (brand.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(brand.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _vm._m(3, true)])
  }))]) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {})])
}]}

/***/ }),

/***/ 557:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "display": "inline-block"
    }
  }, [(_vm.show && _vm.mode != 'first') ? _c('div', {
    staticClass: "settings"
  }, [_c('div', {
    staticClass: "link text-right closeBtn",
    on: {
      "click": function($event) {
        _vm.closeSettings();
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('p', {}, [_vm._v("Erlöse anzeigen")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.showUE == 1
    },
    on: {
      "click": function($event) {
        _vm.showUE = 1;
        _vm.closeSettings();
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" An\r\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.showUE == 0
    },
    on: {
      "click": function($event) {
        _vm.showUE = 0;
        _vm.closeSettings();
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option2",
      "autocomplete": "off"
    }
  }), _vm._v(" Aus\r\n            ")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {}, [_vm._v("Modus")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.modus == ''
    },
    on: {
      "click": function($event) {
        _vm.modus = '';
        _vm.closeSettings();
        _vm.resetSearch();
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" Alle\r\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.modus == 'top'
    },
    on: {
      "click": function($event) {
        _vm.modus = 'top';
        _vm.closeSettings();
        _vm.resetSearch();
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" TOP 5\r\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.modus == 'flop'
    },
    on: {
      "click": function($event) {
        _vm.modus = 'flop';
        _vm.closeSettings();
        _vm.resetSearch();
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option2",
      "autocomplete": "off"
    }
  }), _vm._v(" FLOP 5\r\n            ")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {}, [_vm._v("Vergleich")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.period == 'vormonat' || _vm.period == ''
    },
    on: {
      "click": function($event) {
        _vm.period = 'vormonat';
        _vm.closeSettings();
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" Periode\r\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.period == 'jahr'
    },
    on: {
      "click": function($event) {
        _vm.period = 'jahr';
        _vm.closeSettings();
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" Ganzes Jahr\r\n            ")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.modus == '') ? _c('p', {}, [_vm._v("Sortierung")]) : _vm._e(), _vm._v(" "), (_vm.modus == '') ? _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.sort == 'alpha' || _vm.sort == ''
    },
    on: {
      "click": function($event) {
        _vm.sort = 'alpha';
        _vm.closeSettings();
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" Alphabetisch\r\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.sort == 'revenues'
    },
    on: {
      "click": function($event) {
        _vm.sort = 'revenues';
        _vm.closeSettings();
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" Nach Umsatz\r\n            ")])]) : _vm._e(), _vm._v(" "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.mode == 'first') ? _c('div', {
    staticClass: "settings"
  }, [_c('div', {
    staticClass: "link text-right closeBtn",
    on: {
      "click": function($event) {
        _vm.closeSettings();
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('p', {}, [_vm._v("Erlöse / Gewinnspannen")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.showEG == 1
    },
    on: {
      "click": function($event) {
        _vm.showEG = 1;
        _vm.closeSettings();
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" An\r\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.showEG == 0
    },
    on: {
      "click": function($event) {
        _vm.showEG = 0;
        _vm.closeSettings();
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option2",
      "autocomplete": "off"
    }
  }), _vm._v(" Aus\r\n            ")])]), _vm._v(" "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "settingsOpener",
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 558:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-tabs nav-justified"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'statisticsmc'
      }
    }
  }, [_vm._v("\r\n                Hauptartgrp.\r\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'statisticsb'
      }
    }
  }, [_vm._v("\r\n                Marken\r\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    staticStyle: {
      "padding-bottom": "100px"
    }
  }, [_c('div', {
    staticClass: "tab-pane in active",
    attrs: {
      "id": "hk"
    }
  }, [_c('div', {
    staticClass: "rowX"
  }, [_c('router-view'), _vm._v(" "), (_vm.modus != 'top' && _vm.modus != 'flop') ? _c('searchfield', {
    attrs: {
      "count": _vm.subcategories.length
    }
  }) : _vm._e(), _vm._v(" "), _c('back', {
    attrs: {
      "link": _vm.link
    }
  }), _vm._v(" "), _c('settings'), _vm._v(" "), _c('div', {
    staticClass: "names",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('span', {
    staticClass: "title-one"
  }, [_vm._v(_vm._s(_vm.$parent.names.hatg))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "title-two"
  }, [_vm._v("Artikelgruppen")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.showUE == 1) ? _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary active",
    on: {
      "click": function($event) {
        _vm.mode = '1'
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" Umsatz\r\n                        ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.mode = '2'
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option2",
      "autocomplete": "off"
    }
  }), _vm._v(" Erlös\r\n                        ")])]) : _vm._e()]), _vm._v(" "), (_vm.modus != '') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "30px"
    }
  }, [(_vm.mode == '1') ? _c('div', {
    staticClass: "chart",
    attrs: {
      "id": "atgCustomerChart1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mode == '2') ? _c('div', {
    staticClass: "chart",
    attrs: {
      "id": "atgCustomerChart2"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('years', {
    attrs: {
      "years": _vm.years[1],
      "period": _vm.period
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.mode == '1') ? _c('span', [(_vm.modus != '') ? _c('table', {
    staticClass: "table table-colored card-table"
  }, [_c('tbody', [_vm._l((_vm.subcategories), function(category, index) {
    return (index < 5) ? _c('router-link', {
      key: category.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'statisticsmcyha',
          params: {
            year: _vm.$route.params.year,
            hatg: _vm.$route.params.hatg,
            atg: category.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('atg', category.name)
        }
      }
    }, [_c('td', {
      staticClass: "colorPill"
    }, [_c('span', {
      staticClass: "colorPill"
    }), _vm._v(" " + _vm._s(category.name) + "\r\n                ")]), _vm._v(" "), _c('td', [(category.umsatzNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                        \r\n                                        (" + _vm._s(category.umsatzDiff) + "%)\r\n                                    ")]) : (category.umsatzLj > category.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                        \r\n                                        (" + _vm._s(category.umsatzDiff) + "%)\r\n                                    ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("\r\n                                        \r\n                                        (" + _vm._s(category.umsatzDiff) + "%)\r\n                                    ")]), _vm._v("\r\n                    \r\n                    " + _vm._s(_vm._f("myCurrency")(category.umsatzLj)) + " €\r\n                    "), _c('br'), _vm._v(" "), (category.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])]) : _vm._e()
  }), _vm._v(" "), (_vm.subcategories.length > 5) ? _c('tr', {
    on: {
      "click": function($event) {
        _vm.showmore = !_vm.showmore
      }
    }
  }, [_c('td', [_vm._v("\r\n                        Andere\r\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                        " + _vm._s(_vm._f("myCurrency")(_vm.sum)) + " €\r\n                    ")]), _vm._v(" "), _vm._m(0)]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showmore && _vm.modus != '') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.subcategories), function(category, index) {
    return (index >= 5) ? _c('router-link', {
      key: category.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'statisticsmcyha',
          params: {
            year: _vm.$route.params.year,
            hatg: _vm.$route.params.hatg,
            atg: category.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('hatg', category.name)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('td', [(category.umsatzNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                    \r\n                                    (" + _vm._s(category.umsatzDiff) + "%)\r\n                                ")]) : (category.umsatzLj > category.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                    \r\n                                    (" + _vm._s(category.umsatzDiff) + "%)\r\n                                ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("\r\n                                    \r\n                                    (" + _vm._s(category.umsatzDiff) + "%)\r\n                                ")]), _vm._v(" " + _vm._s(_vm._f("myCurrency")(category.umsatzLj)) + " €\r\n                                "), _c('br'), _vm._v(" "), (category.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])]) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), (_vm.modus == '') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.subcategories), function(category, index) {
    return _c('router-link', {
      key: category.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'statisticsmcyha',
          params: {
            year: _vm.$route.params.year,
            hatg: _vm.$route.params.hatg,
            atg: category.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('hatg', category.name)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('td', [(category.umsatzNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                    \r\n                                    (" + _vm._s(category.umsatzDiff) + "%)\r\n                                ")]) : (category.umsatzLj > category.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                    \r\n                                    (" + _vm._s(category.umsatzDiff) + "%)\r\n                                ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("\r\n                                   \r\n                                    (" + _vm._s(category.umsatzDiff) + "%)\r\n                                ")]), _vm._v(" " + _vm._s(_vm._f("myCurrency")(category.umsatzLj)) + " €\r\n                                "), _c('br'), _vm._v(" "), (category.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])])
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mode == '2') ? _c('span', [(_vm.modus != '') ? _c('table', {
    staticClass: "table table-colored card-table"
  }, [_c('tbody', [_vm._l((_vm.subcategories), function(category, index) {
    return (index < 5) ? _c('router-link', {
      key: category.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'statisticsmcyha',
          params: {
            year: _vm.$route.params.year,
            hatg: _vm.$route.params.hatg,
            atg: category.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('atg', category.name)
        }
      }
    }, [_c('td', {
      staticClass: "colorPill"
    }, [_c('span', {
      staticClass: "colorPill"
    }), _vm._v(" " + _vm._s(category.name) + "\r\n                ")]), _vm._v(" "), _c('td', [(category.erloesNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                        \r\n                                        (" + _vm._s(category.erloesDiff) + "%)\r\n                                    ")]) : (category.erloesLj > category.erloesVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                     \r\n                                        (" + _vm._s(category.erloesDiff) + "%)\r\n                                    ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("\r\n                                        \r\n                                        (" + _vm._s(category.erloesDiff) + "%)\r\n                                    ")]), _vm._v("\r\n                    \r\n                    " + _vm._s(_vm._f("myCurrency")(category.erloesLj)) + " €\r\n                    "), _c('br'), _vm._v(" "), (category.erloesVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.erloesVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])]) : _vm._e()
  }), _vm._v(" "), (_vm.subcategories.length > 5) ? _c('tr', {
    on: {
      "click": function($event) {
        _vm.showmore = !_vm.showmore
      }
    }
  }, [_c('td', [_vm._v("\r\n                        Andere\r\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                        " + _vm._s(_vm._f("myCurrency")(4678956)) + " €\r\n                    ")]), _vm._v(" "), _vm._m(1)]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showmore && _vm.modus != '') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.subcategories), function(category, index) {
    return (index >= 5) ? _c('router-link', {
      key: category.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'statisticsmcyha',
          params: {
            year: _vm.$route.params.year,
            hatg: _vm.$route.params.hatg,
            atg: category.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('hatg', category.name)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('td', [(category.erloesNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                    \r\n                                    (" + _vm._s(category.erloesDiff) + "%)\r\n                                ")]) : (category.erloesLj > category.erloeszVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                    \r\n                                    (" + _vm._s(category.erloesDiff) + "%)\r\n                                ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("\r\n                                    \r\n                                    (" + _vm._s(category.erloesDiff) + "%)\r\n                                ")]), _vm._v(" " + _vm._s(_vm._f("myCurrency")(category.erloesLj)) + " €\r\n                                "), _c('br'), _vm._v(" "), (category.erloesVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.erloesVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])]) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), (_vm.modus == '') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.subcategories), function(category, index) {
    return _c('router-link', {
      key: category.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'statisticsmcyha',
          params: {
            year: _vm.$route.params.year,
            hatg: _vm.$route.params.hatg,
            atg: category.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('hatg', category.name)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('td', [(category.erloesNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                    \r\n                                    (" + _vm._s(category.erloesDiff) + "%)\r\n                                ")]) : (category.erloesLj > category.erloesVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                    \r\n                                    (" + _vm._s(category.erloesDiff) + "%)\r\n                                ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("\r\n                                    \r\n                                    (" + _vm._s(category.erloesDiff) + "%)\r\n                                ")]), _vm._v(" " + _vm._s(_vm._f("myCurrency")(category.erloesLj)) + " €\r\n                                "), _c('br'), _vm._v(" "), (category.erloesVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.erloesVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])])
  }))]) : _vm._e()]) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {
    staticClass: "next"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {
    staticClass: "next"
  })])
}]}

/***/ }),

/***/ 559:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.loader) ? _c('div', {
    staticClass: "loader-wrapper"
  }) : _vm._e(), _vm._v(" "), (_vm.loader) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 560:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-tabs nav-justified"
  }, [_c('li', [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'statisticsmc'
      }
    }
  }, [_vm._v("\r\n                Hauptartgrp.\r\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'statisticsb'
      }
    }
  }, [_vm._v("\r\n                Marken\r\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    staticStyle: {
      "padding-bottom": "100px"
    }
  }, [_c('div', {
    staticClass: "tab-pane in active",
    attrs: {
      "id": "hk"
    }
  }, [_c('div', {
    staticClass: "rowX"
  }, [_c('router-view'), _vm._v(" "), (_vm.modus != 'top' && _vm.modus != 'flop') ? _c('searchfield', {
    attrs: {
      "count": _vm.brands.length
    }
  }) : _vm._e(), _vm._v(" "), _c('back', {
    attrs: {
      "link": "/dashboard/statistics/brands/"
    }
  }), _vm._v(" "), _c('settings'), _vm._v(" "), _c('div', {
    staticClass: "names",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('span', {
    staticClass: "title-one"
  }, [_vm._v("Marken")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "title-two"
  }, [_vm._v("Alle")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.showUE == 1) ? _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary active",
    on: {
      "click": function($event) {
        _vm.mode = '1'
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" Umsatz\r\n                        ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.mode = '2'
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option2",
      "autocomplete": "off"
    }
  }), _vm._v(" Erlös\r\n                        ")])]) : _vm._e()]), _vm._v(" "), (_vm.modus != '') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "chart",
    attrs: {
      "id": "yCustomerChart"
    }
  })]) : _vm._e(), _vm._v(" "), _c('years', {
    attrs: {
      "years": _vm.years[1],
      "period": _vm.period
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.modus != '') ? _c('table', {
    staticClass: "table table-colored card-table"
  }, [_c('tbody', [_vm._l((_vm.brands), function(brand, index) {
    return (index < 5) ? _c('router-link', {
      key: index,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'statisticsbyb',
          params: {
            year: _vm.$route.params.year,
            brand: brand.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('hatg', brand.name)
        }
      }
    }, [_c('td', {
      staticClass: "colorPill"
    }, [_c('span', {
      staticClass: "colorPill"
    }), _vm._v(" " + _vm._s(brand.name) + "\r\n                            ")]), _vm._v(" "), _c('td', [(brand.umsatzNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                        \r\n                                        (" + _vm._s(brand.umsatzDiff) + "%)\r\n                                    ")]) : (brand.umsatzLj > brand.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                        \r\n                                        (" + _vm._s(brand.umsatzDiff) + "%)\r\n                                    ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("\r\n                                        \r\n                                        (" + _vm._s(brand.umsatzDiff) + "%)\r\n                                    ")]), _vm._v(" " + _vm._s(_vm._f("myCurrency")(brand.umsatzLj)) + " €\r\n                                "), _c('br'), _vm._v(" "), (brand.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(brand.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])]) : _vm._e()
  }), _vm._v(" "), (_vm.brands.length > 5) ? _c('tr', {
    on: {
      "click": function($event) {
        _vm.showmore = !_vm.showmore
      }
    }
  }, [_c('td', [_vm._v("\r\n                                Andere\r\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                                " + _vm._s(_vm._f("myCurrency")(_vm.sum)) + " €\r\n                            ")]), _vm._v(" "), _vm._m(0)]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showmore && _vm.modus != '') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.brands), function(brand, index) {
    return (index >= 5) ? _c('router-link', {
      key: index,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'statisticsbyb',
          params: {
            year: _vm.$route.params.year,
            brand: brand.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('hatg', brand.name)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(brand.name))]), _vm._v(" "), _c('td', [(brand.umsatzNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                                    \r\n                                                    (" + _vm._s(brand.umsatzDiff) + "%)\r\n                                                ")]) : (brand.umsatzLj > brand.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                        \r\n                                        (" + _vm._s(brand.umsatzDiff) + "%)\r\n                                    ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("\r\n                                        \r\n                                        (" + _vm._s(brand.umsatzDiff) + "%)\r\n                                    ")]), _vm._v(" " + _vm._s(_vm._f("myCurrency")(brand.umsatzLj)) + " €\r\n                                "), _c('br'), _vm._v(" "), (brand.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(brand.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])]) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), (_vm.modus == '') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.brands), function(brand, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'statisticsbyb',
          params: {
            year: _vm.$route.params.year,
            brand: brand.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('hatg', brand.name)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(brand.name))]), _vm._v(" "), _c('td', [_vm._v("\r\n                                " + _vm._s(brand.umsatzVj) + " / " + _vm._s(brand.umsatzLf) + "\r\n\r\n                                "), (brand.umsatzNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                                    \r\n                                                    (" + _vm._s(brand.umsatzDiff) + "%)\r\n                                                ")]) : (brand.umsatzLj > brand.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                        \r\n                                        (" + _vm._s(brand.umsatzDiff) + "%)\r\n                                    ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("\r\n                                        \r\n                                        (" + _vm._s(brand.umsatzDiff) + "%)\r\n                                    ")]), _vm._v(" " + _vm._s(_vm._f("myCurrency")(brand.umsatzLj)) + " €\r\n                                "), _c('br'), _vm._v(" "), (brand.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(brand.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])])
  }))]) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {
    staticClass: "next"
  })])
}]}

/***/ }),

/***/ 561:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "back",
    staticStyle: {
      "margin-left": "0"
    },
    on: {
      "click": _vm.redirect
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 562:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-tabs nav-justified"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'statisticsmc'
      }
    }
  }, [_vm._v("\r\n                Hauptartgrp.\r\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'statisticsb'
      }
    }
  }, [_vm._v("\r\n                Marken\r\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    staticStyle: {
      "padding-bottom": "100px"
    }
  }, [_c('div', {
    staticClass: "tab-pane in active",
    attrs: {
      "id": "hk"
    }
  }, [_c('div', {
    staticClass: "rowX"
  }, [_c('router-view'), _vm._v(" "), (_vm.modus != 'top' && _vm.modus != 'flop') ? _c('searchfield', {
    attrs: {
      "count": _vm.categories.length
    }
  }) : _vm._e(), _vm._v(" "), _c('back', {
    attrs: {
      "link": "/dashboard/statistics/maincategories/"
    }
  }), _vm._v(" "), _c('settings'), _vm._v(" "), _c('div', {
    staticClass: "names",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('span', {
    staticClass: "title-one"
  }, [_vm._v("Hauptgruppen")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "title-two"
  }, [_vm._v("Alle")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.showUE == 1) ? _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary active",
    on: {
      "click": function($event) {
        _vm.mode = '1'
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" Umsatz\r\n                        ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.mode = '2'
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option2",
      "autocomplete": "off"
    }
  }), _vm._v(" Erlös\r\n                        ")])]) : _vm._e()]), _vm._v(" "), (_vm.modus != '') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "30px"
    }
  }, [(_vm.mode == '1') ? _c('div', {
    staticClass: "chart",
    attrs: {
      "id": "hatgCustomerChart1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mode == '2') ? _c('div', {
    staticClass: "chart",
    attrs: {
      "id": "hatgCustomerChart2"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('years', {
    attrs: {
      "years": _vm.years[1],
      "period": _vm.period
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.mode == '1') ? _c('span', [(_vm.modus != '') ? _c('table', {
    staticClass: "table table-colored card-table"
  }, [_c('tbody', [_vm._l((_vm.categories), function(category, index) {
    return (index < 5) ? _c('router-link', {
      key: category.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'statisticsmcyh',
          params: {
            year: _vm.$route.params.year,
            hatg: category.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('hatg', category.name)
        }
      }
    }, [_c('td', {
      staticClass: "colorPill"
    }, [_c('span', {
      staticClass: "colorPill"
    }), _vm._v(" " + _vm._s(category.name) + "\r\n                ")]), _vm._v(" "), _c('td', [(category.umsatzNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                            \r\n                                            (" + _vm._s(category.umsatzDiff) + "%)\r\n                                        ")]) : (category.umsatzLj > category.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                            \r\n                                            (" + _vm._s(category.umsatzDiff) + "%)\r\n                                        ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("\r\n                                            \r\n                                            (" + _vm._s(category.umsatzDiff) + "%)\r\n                                        ")]), _vm._v("\r\n                   \r\n                    " + _vm._s(_vm._f("myCurrency")(category.umsatzLj)) + " €\r\n                    "), _c('br'), _vm._v(" "), (category.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])]) : _vm._e()
  }), _vm._v(" "), (_vm.categories.length > 5) ? _c('tr', {
    on: {
      "click": function($event) {
        _vm.showmore = !_vm.showmore
      }
    }
  }, [_c('td', [_vm._v("\r\n                        Andere\r\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                        " + _vm._s(_vm._f("myCurrency")(_vm.sum)) + " €\r\n                    ")]), _vm._v(" "), _vm._m(0)]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showmore && _vm.modus != '') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.categories), function(category, index) {
    return (index >= 5) ? _c('router-link', {
      key: category.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'statisticsmcyh',
          params: {
            year: _vm.$route.params.year,
            hatg: category.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('hatg', category.name)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('td', [(category.umsatzNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                                \r\n                                                (" + _vm._s(category.umsatzDiff) + "%)\r\n                                        ")]) : (category.umsatzLj > category.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                            \r\n                                            (" + _vm._s(category.umsatzDiff) + "%)\r\n                                        ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("\r\n                                            \r\n                                            (" + _vm._s(category.umsatzDiff) + "%)\r\n                                        ")]), _vm._v("\r\n                               \r\n                                " + _vm._s(_vm._f("myCurrency")(category.umsatzLj)) + " €\r\n                                "), _c('br'), _vm._v(" "), (category.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])]) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), (_vm.modus == '') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.categories), function(category, index) {
    return _c('router-link', {
      key: category.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'statisticsmcyh',
          params: {
            year: _vm.$route.params.year,
            hatg: category.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('hatg', category.name)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('td', [(category.umsatzNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                            \r\n                                            (" + _vm._s(category.umsatzDiff) + "%)\r\n                                        ")]) : (category.umsatzLj > category.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("(" + _vm._s(category.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("(" + _vm._s(category.umsatzDiff) + "%)")]), _vm._v("\r\n                               \r\n                                " + _vm._s(_vm._f("myCurrency")(category.umsatzLj)) + " €\r\n                                "), _c('br'), _vm._v(" "), (category.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])])
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mode == '2') ? _c('span', [(_vm.modus != '') ? _c('table', {
    staticClass: "table table-colored card-table"
  }, [_c('tbody', [_vm._l((_vm.categories), function(category, index) {
    return (index < 5) ? _c('router-link', {
      key: category.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'statisticsmcyh',
          params: {
            year: _vm.$route.params.year,
            hatg: category.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('hatg', category.name)
        }
      }
    }, [_c('td', {
      staticClass: "colorPill"
    }, [_c('span', {
      staticClass: "colorPill"
    }), _vm._v(" " + _vm._s(category.name) + "\r\n                ")]), _vm._v(" "), _c('td', [(category.erloesNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                                \r\n                                                (" + _vm._s(category.erloesDiff) + "%)\r\n                                            ")]) : (category.erloesLj > category.erloesVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                                \r\n                                                (" + _vm._s(category.erloesDiff) + "%)\r\n                                            ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("\r\n                                                \r\n                                                (" + _vm._s(category.erloesDiff) + "%)\r\n                                            ")]), _vm._v("\r\n                   \r\n                    " + _vm._s(_vm._f("myCurrency")(category.erloesLj)) + " €\r\n                    "), _c('br'), _vm._v(" "), (category.erloesVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.erloesVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])]) : _vm._e()
  }), _vm._v(" "), (_vm.categories.length > 5) ? _c('tr', {
    on: {
      "click": function($event) {
        _vm.showmore = !_vm.showmore
      }
    }
  }, [_c('td', [_vm._v("\r\n                        Andere\r\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                        " + _vm._s(_vm._f("myCurrency")(4678956)) + " €\r\n                    ")]), _vm._v(" "), _vm._m(1)]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showmore && _vm.modus != '') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.categories), function(category, index) {
    return (index >= 5) ? _c('router-link', {
      key: category.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'statisticsmcyh',
          params: {
            year: _vm.$route.params.year,
            hatg: category.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('hatg', category.name)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('td', [(category.erloesNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                                    \r\n                                                    (" + _vm._s(category.erloesDiff) + "%)\r\n                                            ")]) : (category.erloesLj > category.erloesVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                                \r\n                                                (" + _vm._s(category.erloesDiff) + "%)\r\n                                            ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("\r\n                                                \r\n                                                (" + _vm._s(category.erloesDiff) + "%)\r\n                                            ")]), _vm._v("\r\n                                \r\n                                " + _vm._s(_vm._f("myCurrency")(category.erloesLj)) + " €\r\n                                "), _c('br'), _vm._v(" "), (category.erloesVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.erloesVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])]) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), (_vm.sort == '') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.categories), function(category, index) {
    return _c('router-link', {
      key: category.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'statisticsmcyh',
          params: {
            year: _vm.$route.params.year,
            hatg: category.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('hatg', category.name)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('td', [(category.erloesNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                                \r\n                                                (" + _vm._s(category.erloesDiff) + "%)\r\n                                            ")]) : (category.erloesLj > category.erloesVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("(" + _vm._s(category.erloesDiff) + "%)")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("(" + _vm._s(category.erloesDiff) + "%)")]), _vm._v("\r\n                               \r\n                                " + _vm._s(_vm._f("myCurrency")(category.erloesLj)) + " €\r\n                                "), _c('br'), _vm._v(" "), (category.erloesVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.erloesVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])])
  }))]) : _vm._e()]) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {
    staticClass: "next"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {
    staticClass: "next"
  })])
}]}

/***/ }),

/***/ 563:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    class: _vm.additionClassName
  }, [_c('div', {
    staticClass: "card-body",
    class: _vm.bodyClass
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 565:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "/* float": "left",
      "*/margin": "0 auto",
      "text-align": "center",
      "display": "inline-block"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchword),
      expression: "searchword"
    }],
    staticClass: "form-control",
    staticStyle: {
      "display": "inline-block",
      "width": "80%"
    },
    attrs: {
      "placeholder": "Bitte Suchwort eingeben...",
      "type": "text",
      "id": "searchword"
    },
    domProps: {
      "value": (_vm.searchword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchword = $event.target.value
      }
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('layout')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 567:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "statsMaincategory"
  }, [(_vm.settings) ? _c('div', {
    staticClass: "settings"
  }, [_c('div', {
    staticClass: "link text-right closeBtn",
    on: {
      "click": function($event) {
        _vm.closeSettings();
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('p', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.sort = '';
        _vm.fetchData();
        _vm.closeSettings();
      }
    }
  }, [_vm._v("Alle anzeigen")]), _vm._v(" "), _c('p', {
    staticClass: "divider"
  }, [_vm._v("Sortieren")]), _vm._v(" "), _c('p', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.sort = 'alpha';
        _vm.fetchData();
        _vm.closeSettings();
      }
    }
  }, [_vm._v("Alphabetisch")]), _vm._v(" "), _c('p', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.sort = 'revenues';
        _vm.fetchData();
        _vm.closeSettings();
      }
    }
  }, [_vm._v("Nach Umsatz")])]) : _vm._e(), _vm._v(" "), (_vm.loaderSm) ? _c('div', {
    staticClass: "loader-wrapper-sm"
  }) : _vm._e(), _vm._v(" "), (_vm.loaderSm) ? _c('div', {
    staticClass: "loader-sm"
  }) : _vm._e(), _vm._v(" "), (!_vm.$route.params.year) ? _c('card', {
    attrs: {
      "addition-class-name": "card-mini",
      "body-class": "no-padding table-responsiveXX"
    }
  }, [_c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "chartWrapper"
  }, [_c('div', {
    staticClass: "chart col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right"
  }, [_c('div', {
    attrs: {
      "id": "chartHkCustomer"
    }
  })])])])]), _vm._v(" "), _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.yearslist[0]), function(year, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'dsmy',
          params: {
            year: year.jahr
          }
        }
      }
    }, [_c('td', [_vm._v(_vm._s(year.jahr) + " "), _c('span', {
      staticClass: "label label-primary"
    }, [_vm._v("GS: " + _vm._s(year.gewinnSpanne) + " | WB: " + _vm._s(year.webQuote))])]), _vm._v(" "), _c('td', [_vm._v("\r\n                            " + _vm._s(_vm._f("myCurrency")(year.umsatz)) + " €\r\n                        ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.$route.params.year && !_vm.$route.params.cat) ? _c('card', {
    attrs: {
      "title": "Hauptkategorien Statistik",
      "addition-class-name": "card-mini",
      "body-class": "no-padding table-responsiveXX"
    }
  }, [_c('router-link', {
    staticClass: "back",
    attrs: {
      "tag": "div",
      "to": "/dashboard/stats/maincategories"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "settingsOpener",
    on: {
      "click": function($event) {
        _vm.settings = !_vm.settings
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  })]), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chartWrapper"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), (_vm.sort == 'revenues') ? _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "200px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.vG2r == 1) ? _c('svg', {
    attrs: {
      "id": "vG2r-2",
      "width": "300",
      "height": "300"
    }
  }) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "names"
  }, [_c('span', {
    staticClass: "title-one"
  }, [_vm._v("Hauptgruppen")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "title-two"
  }, [_vm._v("Alle")])])]), _vm._v(" "), _c('div', {
    staticClass: "date text-center"
  }, _vm._l((_vm.yearslist[1]), function(item, index) {
    return _c('router-link', {
      key: index,
      class: {
        active: _vm.$route.params.year == item.jahr
      },
      attrs: {
        "to": {
          name: 'dsmy',
          params: {
            year: item.jahr
          }
        }
      },
      on: {
        "click": function($event) {
          _vm.setYear(item.jahr)
        }
      }
    }, [_vm._v("\r\n                    " + _vm._s(item.jahr) + "\r\n                ")])
  })), _vm._v(" "), (_vm.sort == 'revenues') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', [_vm._l((_vm.categories), function(category, index) {
    return (index < 5) ? _c('router-link', {
      key: category.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'dsmc',
          params: {
            year: _vm.$route.params.year,
            cat: category.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('hatg', category.name)
        }
      }
    }, [_c('td', {
      staticClass: "colorPill"
    }, [_c('span', {
      staticClass: "colorPill"
    }), _vm._v(_vm._s(category.name))]), _vm._v(" "), _c('td', [(category.umsatzVj > 0) ? _c('span', [(category.umsatzLj > category.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_c('br'), _vm._v("(" + _vm._s(category.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward"
    }, [_c('br'), _vm._v("(" + _vm._s(category.umsatzDiff) + "%)")])]) : _vm._e(), _vm._v(_vm._s(_vm._f("myCurrency")(category.umsatzLj)) + " €"), _c('br'), (category.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])]) : _vm._e()
  }), _vm._v(" "), (_vm.categories.length > 5) ? _c('tr', {
    on: {
      "click": function($event) {
        _vm.showmore = !_vm.showmore
      }
    }
  }, [_c('td', [_vm._v("\r\n                            Andere\r\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                            " + _vm._s(_vm._f("myCurrency")(4678956)) + " €\r\n                        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {
    staticClass: "next"
  })])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showmore && _vm.sort == 'revenues') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.categories), function(category, index) {
    return (index >= 5) ? _c('router-link', {
      key: category.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'dsmc',
          params: {
            year: _vm.$route.params.year,
            cat: category.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('hatg', category.name)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('td', [(category.umsatzVj > 0) ? _c('span', [(category.umsatzLj > category.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_c('br'), _vm._v("(" + _vm._s(category.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward"
    }, [_c('br'), _vm._v("(" + _vm._s(category.umsatzDiff) + "%)")])]) : _vm._e(), _vm._v(_vm._s(_vm._f("myCurrency")(category.umsatzLj)) + " €"), _c('br'), (category.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])]) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), (_vm.sort != 'revenues') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.categories), function(category, index) {
    return _c('router-link', {
      key: category.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'dsmc',
          params: {
            year: _vm.$route.params.year,
            cat: category.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('hatg', category.name)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('td', [(category.umsatzVj > 0) ? _c('span', [(category.umsatzLj > category.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_c('br'), _vm._v("(" + _vm._s(category.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward"
    }, [_c('br'), _vm._v("(" + _vm._s(category.umsatzDiff) + "%)")])]) : _vm._e(), _vm._v(_vm._s(_vm._f("myCurrency")(category.umsatzLj)) + " €"), _c('br'), (category.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])])
  }))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.year && _vm.$route.params.cat && !_vm.$route.params.scat) ? _c('card', {
    attrs: {
      "title": "Hauptkategorien Statistik",
      "addition-class-name": "card-mini",
      "body-class": "no-padding table-responsiveXX"
    }
  }, [_c('router-link', {
    staticClass: "back",
    attrs: {
      "tag": "div",
      "to": {
        name: 'dsmy',
        params: {
          year: _vm.$route.params.year
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "settingsOpener",
    on: {
      "click": function($event) {
        _vm.settings = !_vm.settings
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  })]), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chartWrapper"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), (_vm.sort == 'revenues') ? _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "200px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.vG3r == 1) ? _c('svg', {
    attrs: {
      "id": "vG3r-2",
      "width": "300",
      "height": "300"
    }
  }) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "names"
  }, [_c('span', {
    staticClass: "title-one"
  }, [_vm._v(_vm._s(_vm.names.hatg))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "title-two"
  }, [_vm._v("Artikelgruppen")])])]), _vm._v(" "), _c('div', {
    staticClass: "date text-center"
  }, _vm._l((_vm.yearslist[1]), function(item, index) {
    return _c('router-link', {
      key: index,
      class: {
        active: _vm.$route.params.year == item.jahr
      },
      attrs: {
        "to": {
          name: 'dsmc',
          params: {
            year: item.jahr,
            cat: _vm.$route.params.cat
          }
        }
      },
      on: {
        "click": function($event) {
          _vm.setYear(item.jahr)
        }
      }
    }, [_vm._v("\r\n                    " + _vm._s(item.jahr) + "\r\n                ")])
  })), _vm._v(" "), (_vm.sort == 'revenues') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', [_vm._l((_vm.subcategories), function(subcategory, index) {
    return (index < 5) ? _c('router-link', {
      key: index,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'dsms',
          params: {
            year: _vm.$route.params.year,
            cat: _vm.$route.params.cat,
            scat: subcategory.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('atg', subcategory.name)
        }
      }
    }, [_c('td', {
      staticClass: "colorPill"
    }, [_c('span', {
      staticClass: "colorPill"
    }), _vm._v(_vm._s(subcategory.name))]), _vm._v(" "), _c('td', [(subcategory.umsatzVj > 0) ? _c('span', [(subcategory.umsatzLj > subcategory.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_c('br'), _vm._v("(" + _vm._s(subcategory.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward"
    }, [_c('br'), _vm._v("(" + _vm._s(subcategory.umsatzDiff) + "%)")])]) : _vm._e(), _vm._v(_vm._s(_vm._f("myCurrency")(subcategory.umsatzLj)) + " €"), _c('br'), _vm._v(" "), (subcategory.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(subcategory.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])]) : _vm._e()
  }), _vm._v(" "), (_vm.subcategories.length > 5) ? _c('tr', {
    on: {
      "click": function($event) {
        _vm.showmore = !_vm.showmore
      }
    }
  }, [_c('td', [_vm._v("\r\n                            Andere\r\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                            " + _vm._s(_vm._f("myCurrency")(4678956)) + " €\r\n                        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {
    staticClass: "next"
  })])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showmore && _vm.sort == 'revenues') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.subcategories), function(subcategory, index) {
    return (index >= 5) ? _c('router-link', {
      key: index,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'dsms',
          params: {
            year: _vm.$route.params.year,
            cat: _vm.$route.params.cat,
            scat: subcategory.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('atg', subcategory.name)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(subcategory.name))]), _vm._v(" "), _c('td', [(subcategory.umsatzVj > 0) ? _c('span', [(subcategory.umsatzLj > subcategory.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_c('br'), _vm._v("(" + _vm._s(subcategory.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward"
    }, [_c('br'), _vm._v("(" + _vm._s(subcategory.umsatzDiff) + "%)")])]) : _vm._e(), _vm._v(_vm._s(_vm._f("myCurrency")(subcategory.umsatzLj)) + " €"), _c('br'), _vm._v(" "), (subcategory.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(subcategory.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])]) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), (_vm.sort != 'revenues') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.subcategories), function(subcategory, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'dsms',
          params: {
            year: _vm.$route.params.year,
            cat: _vm.$route.params.cat,
            scat: subcategory.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('atg', subcategory.name)
        }
      }
    }, [_c('td', [_vm._v(" " + _vm._s(subcategory.name))]), _vm._v(" "), _c('td', [(subcategory.umsatzVj > 0) ? _c('span', [(subcategory.umsatzLj > subcategory.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_c('br'), _vm._v("(" + _vm._s(subcategory.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward"
    }, [_c('br'), _vm._v("(" + _vm._s(subcategory.umsatzDiff) + "%)")])]) : _vm._e(), _vm._v(_vm._s(_vm._f("myCurrency")(subcategory.umsatzLj)) + " €"), _c('br'), _vm._v(" "), (subcategory.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(subcategory.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])])
  }))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.year && _vm.$route.params.cat && _vm.$route.params.scat && !_vm.$route.params.brand) ? _c('card', {
    attrs: {
      "title": "Hauptkategorien Statistik",
      "addition-class-name": "card-mini",
      "body-class": "no-padding table-responsiveXX"
    }
  }, [_c('router-link', {
    staticClass: "back",
    attrs: {
      "tag": "div",
      "to": {
        name: 'dsmc',
        params: {
          year: _vm.$route.params.year,
          cat: _vm.$route.params.cat
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "settingsOpener",
    on: {
      "click": function($event) {
        _vm.settings = !_vm.settings
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  })]), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chartWrapper"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "names"
  }, [_c('span', {
    staticClass: "title-one"
  }, [_vm._v(_vm._s(_vm.names.atg))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "title-two"
  }, [_vm._v("Marken")])])]), _vm._v(" "), _c('div', {
    staticClass: "date text-center"
  }, _vm._l((_vm.yearslist[1]), function(item, index) {
    return _c('router-link', {
      key: index,
      class: {
        active: _vm.$route.params.year == item.jahr
      },
      attrs: {
        "to": {
          name: 'dsms',
          params: {
            year: item.jahr,
            cat: _vm.$route.params.cat,
            scat: _vm.$route.params.scat
          }
        }
      },
      on: {
        "click": function($event) {
          _vm.setYear(item.jahr)
        }
      }
    }, [_vm._v("\r\n                    " + _vm._s(item.jahr) + "\r\n                ")])
  })), _vm._v(" "), (_vm.sort == 'revenues') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', [_vm._l((_vm.brands), function(brand, index) {
    return (index < 5) ? _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "colorPillX"
    }, [_c('span', {
      staticClass: "colorPillX"
    }), _vm._v(_vm._s(brand.name))]), _vm._v(" "), _c('td', [(brand.umsatzVj > 0) ? _c('span', [(brand.umsatzLj > brand.umsatzVj) ? _c('span', {
      staticClass: "upward text-success"
    }, [_c('br'), _vm._v("(" + _vm._s(brand.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward text-danger"
    }, [_c('br'), _vm._v("(" + _vm._s(brand.umsatzDiff) + "%)")])]) : _vm._e(), _vm._v(_vm._s(_vm._f("myCurrency")(brand.umsatzLj)) + " €"), _c('br'), _vm._v(" "), (brand.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(brand.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])])]) : _vm._e()
  }), _vm._v(" "), (_vm.brands.length > 5) ? _c('tr', {
    on: {
      "click": function($event) {
        _vm.showmore = !_vm.showmore
      }
    }
  }, [_c('td', [_vm._v("\r\n                            Andere\r\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                            " + _vm._s(_vm._f("myCurrency")(4678956)) + " €\r\n                        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {
    staticClass: "next"
  })])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showmore && _vm.sort == 'revenues') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.brands), function(brand, index) {
    return (index >= 5) ? _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(brand.name))]), _vm._v(" "), _c('td', [(brand.umsatzVj > 0) ? _c('span', [(brand.umsatzLj > brand.umsatzVj) ? _c('span', {
      staticClass: "upward text-success"
    }, [_c('br'), _vm._v("(" + _vm._s(brand.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward text-danger"
    }, [_c('br'), _vm._v("(" + _vm._s(brand.umsatzDiff) + "%)")])]) : _vm._e(), _vm._v(_vm._s(_vm._f("myCurrency")(brand.umsatzLj)) + " €"), _c('br'), _vm._v(" "), (brand.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(brand.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])])]) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), (_vm.sort != 'revenues') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.brands), function(brand, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(brand.name))]), _vm._v(" "), _c('td', [(brand.umsatzVj > 0) ? _c('span', [(brand.umsatzLj > brand.umsatzVj) ? _c('span', {
      staticClass: "upward text-success"
    }, [_c('br'), _vm._v("(" + _vm._s(brand.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward text-danger"
    }, [_c('br'), _vm._v("(" + _vm._s(brand.umsatzDiff) + "%)")])]) : _vm._e(), _vm._v(_vm._s(_vm._f("myCurrency")(brand.umsatzLj)) + " €"), _c('br'), _vm._v(" "), (brand.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(brand.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])])])
  }))]) : _vm._e()], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 568:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-tabs nav-justified"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'statisticsmc'
      }
    }
  }, [_vm._v("\r\n                Hauptartgrp.\r\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'statisticsb'
      }
    }
  }, [_vm._v("\r\n                Marken\r\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    staticStyle: {
      "padding-bottom": "100px"
    }
  }, [_c('div', {
    staticClass: "tab-pane in active",
    attrs: {
      "id": "hk"
    }
  }, [_c('div', {
    staticClass: "rowX text-center"
  }, [_c('settings', {
    attrs: {
      "mode": "first"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary active",
    on: {
      "click": function($event) {
        _vm.drawChart()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" Umsatz\r\n                    ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.drawChart(true)
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option2",
      "autocomplete": "off"
    }
  }), _vm._v(" Quoten\r\n                    ")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-colored card-table"
  }, [_c('tbody', _vm._l((_vm.years[0]), function(year, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'statisticsmcy',
          params: {
            year: year.jahr
          }
        }
      }
    }, [_c('td', [_vm._v(_vm._s(year.jahr))]), _vm._v(" "), _c('td', [_vm._v("\r\n                                " + _vm._s(_vm._f("myCurrency")(year.umsatz)) + " €\r\n                            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])])
  }))])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "chart",
    attrs: {
      "id": "yCustomerChart"
    }
  })])
}]}

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(235);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(571)("0247cdf2", content, true);

/***/ }),

/***/ 574:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[233]);


// WEBPACK FOOTER //
// static/js/app.b72e50e7872a55b18c2b.js